import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Col,
  PageHeader,
  Row,
  Spin,
  Form as FormInitial,
  message,
  Select,
  Switch,
  Tabs,
  Tooltip,
  Space,
  Tag,
  Input,
  Progress,
  Button,
} from "antd";
import {
  ButtonItem,
  Form,
  InputNumberItem,
  ModalItem,
  SelectItem,
  TextAreaItem,
  FormItem,
  ErrorItem,
  DatePickerItem,
  dineroDisabledMask,
  round2Decimals,
  TreeSelectItem,
  SelectInsumosItem,
  SwitchItem,
  DisponibilidadInsumoModal
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import AyudaConversion from "../../../../Components/AyudaConversion";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import axios from "axios";
import { ArrowUpOutlined, CalculatorOutlined, CarOutlined, CheckCircleFilled, CheckCircleOutlined, CloseCircleOutlined, EnvironmentOutlined, FireOutlined, InfoCircleOutlined, WarningOutlined, SearchOutlined, GlobalOutlined, LoadingOutlined, ClockCircleOutlined, UserOutlined, CommentOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import moment from "moment";
import AsignarProveedor from "../AsignarProveedor/AsignarProveedor";
import ModalAgregarInsumosAExistente from "../ModalAgregarInsumosAExistente/ModalAgregarInsumosAExistente";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import ModalVerRequisicion from "../ModalVerRequisicion/ModalVerRequisicion";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";

const { Option } = Select;
const { TabPane } = Tabs;

// Días de la semana
const DIAS_SEMANA = [
  { key: "viernes",   label: "Vie" },
  { key: "sabado",    label: "Sáb" },
  { key: "domingo",   label: "Dom" },
  { key: "lunes",     label: "Lun" },
  { key: "martes",    label: "Mar" },
  { key: "miercoles", label: "Mié" },
  { key: "jueves",    label: "Jue" },
];

// Máximo pedible en unidad del proveedor: cantidad pendiente convertida a "paquetes" de tamaño `conversion`,
// redondeando hacia arriba solo cuando la conversión agrupa unidades (conversion > 1); con conversion = 1
// no hay empaque que redondear y se respeta el decimal tal cual.
function calcularMaximoConversion(cantidad, cantidadOrdenada, conversion) {
  if (!cantidad) return undefined;
  const co = cantidadOrdenada || 0;
  if (co > cantidad) return 0;
  const pendiente = cantidad - co;
  if (conversion === 1) return pendiente;
  const r = pendiente % conversion;
  return r !== 0 ? Math.floor(pendiente / conversion) + 1 : pendiente / conversion;
}

class GenerarOrdenDeCompraConRequisicion extends Component {
  formRef = React.createRef();

  // Familias colapsadas por pestaña. La agrupación por familia aquí ya era
  // permanente (los renglones vienen ordenados por familia y llevan banner); lo
  // único que se agrega es poder cerrarlas. Todas abren expandidas.
  //
  // Colapsar ESCONDE el <tbody> del renglón (display:none), no lo desmonta: las
  // filas traen FormItem required y antd sólo valida los campos montados, así que
  // desmontarlas dejaría pasar una partida incompleta escondida. Va fuera de
  // `state` porque no participa en ningún cálculo: sólo pinta.
  familiasColapsadas = { manual: new Set(), inteligente: new Set(), default: new Set() };

  claveFamilia = (familiaId) => (familiaId ? familiaId.toString() : "sin-familia");

  alternarFamilia = (tabla, familiaId) => {
    const clave = this.claveFamilia(familiaId);
    const actuales = this.familiasColapsadas[tabla];
    if (actuales.has(clave)) actuales.delete(clave);
    else actuales.add(clave);
    this.forceUpdate();
  };

  familiaColapsada = (tabla, familiaId) =>
    this.familiasColapsadas[tabla].has(this.claveFamilia(familiaId));

  // Cuántos renglones trae la familia, para el encabezado. Aquí no se muestra un
  // subtotal por familia como en Agregar/Editar OC: esta pantalla no pinta
  // importe por renglón (decide cuánto pedir y a quién). El único importe es el
  // total general al pie (calcularTotalesPedido), y sólo con
  // mostrarCostosRequisicion prendido.
  contarPartidasFamilia = (insumos, familiaId) => {
    const clave = this.claveFamilia(familiaId);
    return (insumos || []).filter((i) => this.claveFamilia(i?.familiaId) === clave).length;
  };

  state = {
    loading: false,
    activeTab: '1',
    objetoProveedores: [],
    objetoInsumosPInsumos: [],
    todasInsumosPInsumos: [],
    objetoProveedoresPInsumos: [],
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: null,
    todasInsumos: [],
    impuestos: [],
    numeroRequisicion: 0,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    valuesForm: null,
    modalConfirmacion: false,
    numOrdenesAGenerar: 0,
    loadingPedidoInteligente: false,
    tipo: 1,
    modalAsignarProveedor: false,
    modalAsignarProveedorInsumoId: null,
    modalAgregarAOrdenDeCompraExistente: false,
    modalAgregarAOrdenDeCompraExistenteInsumos: [],
    modalAgregarAOrdenDeCompraExistenteProveedorId: null,
    workbench: this.props?.location?.state?.workbench || false,
    requisicionesAdicionales: [],
    modalObservaciones: false,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    modalObservacionesObservacionesXml: false,
    // Si la requisición tiene separarDias activo
    separarDias: false,
    // Días seleccionados por insumo: { [arrayKey]: Set<string> }
    diasSeleccionados: {},
    // Para la barra de busqueda 
    busquedaInsumo: "",
    insumoResaltado: null,
    verInventario: false,
    inventarioData: {},
    loadingInventario: false,
    modalConfirmarConsultarPrecios: false,
    modalConsultarPrecios: false,
    loadingConsultarPrecios: false,
    consultarPreciosData: null,
    proveedoresAsignadosScrap: {},
    relacionesAsignadasScrap: {},
    ocultarInsumosSinResultados: false,
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '', proyectoId: null },
    // Complemento "Mostrar Costos en Requisicion": con él prendido se pinta el total al pie
    mostrarCostosRequisicion: false,
  };

  componentDidMount() {
    this.consultarTodo();
    // Aparte de consultarTodo: ese se vuelve a llamar al cerrar Asignar Proveedor
    // y la bandera no cambia mientras la pantalla está abierta.
    axios.post(
      "requisiciones/configuracionRequisiciones",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    ).then((res) => {
      if (res.data?.success === 2) {
        this.setState({ mostrarCostosRequisicion: !!res.data.mostrarCostosRequisicion });
      }
    });
  }

  // Total de lo que se va a pedir, con la misma fórmula con la que el back arma
  // la O/C (generarOrdenesDeCompra / ...Inteligente / ...ProveedorDefault):
  // precio = costo de la relación (por paquete del proveedor, igual que `pedir`)
  // o del insumo; subtotal redondeado por renglón; impuestos del insumo salvo
  // proveedor extranjero; total = subtotal + impuestos, sin restar retenciones.
  // Puede diferir en centavos: el back redondea por impuesto agrupado.
  calcularTotalesPedido(filas) {
    let subtotal = 0;
    let impuestos = 0;
    for (const fila of filas || []) {
      const pedir = Number(fila?.pedir) || 0;
      if (pedir <= 0 || !fila.proveedorId || !fila.insumoProveedorId) continue;
      const insumo = this.state.todasInsumos.find(i => i._id?.toString() === fila.insumoId?.toString());
      if (!insumo) continue;
      const relacion = insumo.relaciones?.find(r => r._id?.toString() === fila.insumoProveedorId.toString());
      const precio = relacion ? (relacion.costo || insumo.costo) : insumo.costo;
      if (!precio) continue;

      const subtotalFila = round2Decimals(pedir * precio);
      subtotal += subtotalFila;

      const proveedor = this.state.todasProveedores?.find(p => p._id?.toString() === fila.proveedorId.toString());
      if (proveedor?.proveedorExtranjero) continue;
      let impuestosFila = 0;
      for (const impuesto of insumo.impuestos || []) {
        if (impuesto.tasaCuota === 1) impuestosFila += subtotalFila * (impuesto.monto / 100);
        else if (impuesto.tasaCuota === 2) impuestosFila += (subtotalFila + impuestosFila) * (impuesto.monto / 100);
        else if (impuesto.tasaCuota === 3) impuestosFila += pedir * impuesto.monto;
        // 4 y 5 quedan en 0 en la O/C generada
      }
      impuestos += impuestosFila;
    }
    subtotal = round2Decimals(subtotal);
    impuestos = round2Decimals(impuestos);
    return { subtotal, impuestos, total: round2Decimals(subtotal + impuestos) };
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo(preserveFormValues = false, modalAsignarProveedorKey = null, nuevoInsumo = null) {
    this.setState({ loading: true });
    const responseProveedores = axios.post(
      "proveedores/selectProveedoresConTipoDeProveedor",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responseProyectos = axios.post(
      "proyectos/selectProyectos",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responses = await Promise.all([responseProveedores, responseProyectos]);

    let newState = {};

    if (responses[0].data.status !== 404) {
      newState.todasProveedores = responses[0].data;
      newState.objetoProveedores = responses[0].data.map((value) => (
        <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
      ));
    }

    if (responses[1].data.status !== 404) {
      newState.todasProyectos = responses[1].data;
      newState.objetoProyectos = responses[1].data.map((value) => (
        <Option value={value._id} key={value._id}>{value.nombre}</Option>
      ));
    }

    await this.promisedSetState(newState);

    let secondState = { loading: false };

    await axios
      .post(
        this.state.workbench ? "workbenchRequisiciones/datosWorkBench" : "requisiciones/datosRequisicion",
        {
          empresaId: this.props.empresaId,
          requisicionId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          secondState.separarDias = !!res.data.requisicion.separarDias;

          let insumosEditados = (res.data.requisicion.insumos && res.data.requisicion?.insumos?.length > 0)
            ? res.data.requisicion.insumos.map(valueInsumo => {
              let insumoBuscar = res.data.insumos.find(valueTI => valueTI._id.toString() === valueInsumo.insumoId.toString());
              return {
                ...valueInsumo,
                descripcion: insumoBuscar ? insumoBuscar.descripcion : '',
                familiaNombre: insumoBuscar?.familia?.nombre ? insumoBuscar.familia.nombre : '',
                familiaId: insumoBuscar?.familiaId ? insumoBuscar.familiaId : '',
                fechaEntrega: valueInsumo.fechaEntrega ? moment(valueInsumo.fechaEntrega) : null,
              };
            }).sort((a, b) => {
              let familiaCompare;
              if (a.familiaNombre && b.familiaNombre) familiaCompare = a.familiaNombre.localeCompare(b.familiaNombre);
              else if (a.familiaNombre) familiaCompare = -1;
              else if (b.familiaNombre) familiaCompare = 1;
              else familiaCompare = 0;
              if (familiaCompare !== 0) return familiaCompare;
              return 0;
            })
            : [];

          if (insumosEditados && insumosEditados.length > 0) {
            let objetoProveedoresPInsumos = insumosEditados.map(valueInsumo => {
              const insumo = res.data.insumos.find((valueInsumos) => valueInsumos._id === valueInsumo.insumoId);
              if (!insumo) return (<Option value={0} key={0} disabled>Seleccione un insumo para ver sus proveedores</Option>);

              let objetoProveedores = [];
              if (insumo.relaciones && insumo.relaciones?.length > 0) {
                let keysProveedores = [];
                for (const relacion of insumo.relaciones) {
                  if (relacion.estado !== 0) {
                    const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString());
                    if (indexProv === -1) keysProveedores.push(relacion.proveedorId.toString());
                  }
                }
                for (const proveedorId of keysProveedores) {
                  const proveedor = this.state.todasProveedores.find(
                    (valueProveedores) => valueProveedores._id.toString() === proveedorId.toString()
                  );
                  if (!proveedor) continue;
                  let relacionesObject = [];
                  for (const relacion of insumo.relaciones) {
                    if (relacion.estado !== 0 && relacion.proveedorId.toString() === proveedorId.toString()) {
                      relacionesObject.push({
                        value: relacion._id,
                        costo: relacion.costo,
                        conversion: relacion.conversion,
                        key: relacion._id,
                        title: relacion.descripcion + ((relacion.costo && !isNaN(relacion.costo)) ? (' ' + dineroDisabledMask(round2Decimals(relacion.costo / (relacion.conversion || 1)))) : ''),
                      });
                    }
                  }
                  objetoProveedores.push({ value: proveedor._id, key: proveedor._id, title: proveedor.stringBuscar, children: relacionesObject });
                }
              }
              return objetoProveedores;
            });

            let objetoInsumosPInsumos = insumosEditados.map((valueInsumo, indexInsumo) => {
              const insumo = res.data.insumos.find((valueInsumos) => valueInsumos._id === valueInsumo.insumoId);
              if (!valueInsumo.proveedorId) return (<Option value={0} key={0} disabled>Seleccione un proveedor para ver sus insumos</Option>);
              let objetoInsumos = [];
              if (insumo.relaciones && insumo.relaciones?.length > 0) {
                let todasRelaciones = [];
                for (const relacion of insumo.relaciones) {
                  if (relacion.estado !== 0 && relacion.proveedorId.toString() === valueInsumo.proveedorId.toString()) {
                    objetoInsumos.push(<Option value={relacion._id} key={relacion._id}>{relacion.descripcion + ((relacion.costo && !isNaN(relacion.costo)) ? (' ' + dineroDisabledMask(relacion.costo)) : '')}</Option>);
                    todasRelaciones.push(relacion);
                  }
                }
                if (todasRelaciones.length === 1) {
                  insumosEditados[indexInsumo].insumoProveedorId = todasRelaciones[0]._id;
                  insumosEditados[indexInsumo].conversion = todasRelaciones[0].conversion;
                  insumosEditados[indexInsumo].costo = todasRelaciones[0].costo;
                }
              }
              return objetoInsumos;
            });

            let todasInsumosPInsumos = insumosEditados.map(valueInsumo => {
              const insumo = res.data.insumos.find((valueInsumos) => valueInsumos._id === valueInsumo.insumoId);
              if (!valueInsumo.proveedorId) return {};
              let objetoInsumos = [];
              if (insumo.relaciones && insumo.relaciones?.length > 0) {
                for (const relacion of insumo.relaciones) {
                  if (relacion.estado !== 0 && relacion.proveedorId.toString() === valueInsumo.proveedorId.toString()) {
                    objetoInsumos.push(relacion);
                  }
                }
              }
              return objetoInsumos;
            });

            secondState.todasInsumosPInsumos = todasInsumosPInsumos;
            secondState.objetoInsumosPInsumos = objetoInsumosPInsumos;
            secondState.objetoProveedoresPInsumos = objetoProveedoresPInsumos;
          }

          secondState.numeroRequisicion = (res.data.requisicion?.serie ? (res.data.requisicion.serie + " ") : "") + res.data.requisicion.numero;
          secondState.todasInsumos = res.data.insumos;
          secondState.requisicionesAdicionales = res.data.requisicionesAdicionales || [];

          const currentFormValues = preserveFormValues ? this.formRef.current.getFieldsValue() : null;
          if(currentFormValues){
            let mandarAOnChangeProveedorId;
            let mandarAOnChangeProveedorKey;
            const insumosPonerEnForm = currentFormValues.insumos ? currentFormValues.insumos.map((valueInsumo, index) => {
              if (index === modalAsignarProveedorKey && nuevoInsumo && Array.isArray(nuevoInsumo?.relaciones) && nuevoInsumo?.relaciones?.length > 0) {
                const ultimaRelacion = nuevoInsumo.relaciones[nuevoInsumo.relaciones.length - 1];
                mandarAOnChangeProveedorId = ultimaRelacion._id;
                mandarAOnChangeProveedorKey = index
                return { ...valueInsumo, insumoProveedorId: ultimaRelacion._id, proveedorId: ultimaRelacion.proveedorId, conversion: ultimaRelacion.conversion, costo: ultimaRelacion.costo };
              } else {
                return valueInsumo;
              }
            }) : [];
            this.formRef.current.setFieldsValue({
              ...currentFormValues,
              insumos: insumosPonerEnForm
            });
            if (mandarAOnChangeProveedorId && (mandarAOnChangeProveedorKey || mandarAOnChangeProveedorKey === 0)) {
              this.onChangeProveedor(mandarAOnChangeProveedorId, mandarAOnChangeProveedorKey);
            }
          } else {
            this.formRef.current.setFieldsValue({
              ...res.data.requisicion,
              insumos: insumosEditados,
              fechaEntrega: res.data.requisicion.fechaEntrega ? moment(res.data.requisicion.fechaEntrega) : null,
              fechaSolicitud: res.data.requisicion.fechaSolicitud ? moment(res.data.requisicion.fechaSolicitud) : null,
            });
          }

        } else {
          message.error("Error no se encontro informacion de la requisición");
        }
      });

    await this.promisedSetState(secondState);

    axios.post(
      "usuarios/selectUsuariosEmpresa",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    ).then(res => {
      if (res.data.status === 404) return [];
      this.setState({
        todosUsuarios: res.data,
        objetoUsuarios: res.data.map((value) => (
          <Option value={value._id} key={value._id}>{value.nombre} {value.apellidoPaterno} {value.apellidoMaterno}</Option>
        ))
      });
    });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  // ── Toggle de un día para un insumo específico ──
  toggleDia(arrayKey, diaKey, cantidadDia) {
    if (!cantidadDia || cantidadDia <= 0) return; // No se puede seleccionar un día sin cantidad

    const diasSeleccionados = { ...this.state.diasSeleccionados };
    const seleccionados = new Set(diasSeleccionados[arrayKey] || []);

    if (seleccionados.has(diaKey)) {
      seleccionados.delete(diaKey);
    } else {
      seleccionados.add(diaKey);
    }

    diasSeleccionados[arrayKey] = seleccionados;
    this.setState({ diasSeleccionados }, () => this.actualizarPedirPorDias(arrayKey));
  }

  // Escribe una sola fila de "insumos" dándole identidad nueva solo a esa fila
  // (las demás conservan su referencia), para que los shouldUpdate acotados por
  // fila puedan detectar el cambio. Mismo patrón que AgregarOrdenDeCompra.
  aplicarFila(key, arrayValue) {
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = { ...arrayValue[key] };
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // ── Cálculo puro del "pedir" de una fila según los días seleccionados ──
  // Extraído para poder recalcular varias filas y escribirlas de un solo golpe
  // (ver toggleDiaGlobal): antes cada fila hacía su propio setFieldsValue.
  calcularPedir(fila, seleccionados) {
    const diasData = fila?.cantidadPorDia || {};
    const conversion = fila?.conversion || 1;

    // Suma de las cantidades de los días seleccionados
    const totalDiasSeleccionados = DIAS_SEMANA.reduce((acc, dia) => {
      if (seleccionados.has(dia.key)) {
        return acc + (Number(diasData[dia.key]) || 0);
      }
      return acc;
    }, 0);

    // Calcular cuántas "conversiones" se necesitan para cubrir el total de días seleccionados
    let pedir = 0;
    if (totalDiasSeleccionados > 0) {
      const residuo = totalDiasSeleccionados % conversion;
      if (residuo !== 0) {
        pedir = Math.floor(totalDiasSeleccionados / conversion) + 1;
      } else {
        pedir = totalDiasSeleccionados / conversion;
      }
    }

    return pedir || null;
  }

  // ── Recalcula el campo "pedir" de una o varias filas en UNA sola escritura ──
  actualizarPedirPorDias(arrayKeys) {
    const claves = Array.isArray(arrayKeys) ? arrayKeys : [arrayKeys];
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos || !claves.length) return;

    const nuevosInsumos = [...insumos];
    let huboCambio = false;
    for (const arrayKey of claves) {
      if (!nuevosInsumos[arrayKey]) continue;
      const seleccionados = this.state.diasSeleccionados[arrayKey] || new Set();
      const pedir = this.calcularPedir(nuevosInsumos[arrayKey], seleccionados);
      nuevosInsumos[arrayKey] = { ...nuevosInsumos[arrayKey], pedir };
      huboCambio = true;
    }

    if (huboCambio) {
      this.formRef.current.setFieldsValue({ insumos: nuevosInsumos });
    }
  }

  // ── Seleccionar/deseleccionar todos los días de un insumo ──
  toggleTodosDias(arrayKey) {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos || !insumos[arrayKey]) return;

    const diasData = insumos[arrayKey]?.cantidadPorDia || {};
    const diasConCantidad = DIAS_SEMANA.filter(dia => (Number(diasData[dia.key]) || 0) > 0).map(dia => dia.key);

    if (diasConCantidad.length === 0) return;

    const diasSeleccionados = { ...this.state.diasSeleccionados };
    const seleccionados = diasSeleccionados[arrayKey] || new Set();

    // Si todos están seleccionados, deseleccionar todos; si no, seleccionar todos
    const todosSeleccionados = diasConCantidad.every(k => seleccionados.has(k));

    if (todosSeleccionados) {
      diasSeleccionados[arrayKey] = new Set();
    } else {
      diasSeleccionados[arrayKey] = new Set(diasConCantidad);
    }

    this.setState({ diasSeleccionados }, () => this.actualizarPedirPorDias(arrayKey));
  }

  // ── Toggle de un día para TODOS los insumos a la vez ──
  toggleDiaGlobal(diaKey) {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos || insumos.length === 0) return;

    const diasSeleccionados = { ...this.state.diasSeleccionados };

    // Determinar si ese día ya está seleccionado en TODOS los insumos que lo tienen
    const insumosConEseDia = insumos
      .map((ins, idx) => ({ ins, idx }))
      .filter(({ ins }) => (Number(ins.cantidadPorDia?.[diaKey]) || 0) > 0);

    if (insumosConEseDia.length === 0) return;

    const todosYaSeleccionados = insumosConEseDia.every(({ idx }) => {
      const sel = diasSeleccionados[idx] || new Set();
      return sel.has(diaKey);
    });

    // Si todos ya están seleccionados → deseleccionar; si no → seleccionar
    insumosConEseDia.forEach(({ idx }) => {
      const sel = new Set(diasSeleccionados[idx] || []);
      if (todosYaSeleccionados) {
        sel.delete(diaKey);
      } else {
        sel.add(diaKey);
      }
      diasSeleccionados[idx] = sel;
    });

    // Una sola escritura al formulario para todos los insumos afectados: antes
    // era un setFieldsValue del arreglo completo POR insumo (O(N²) en un clic).
    this.setState({ diasSeleccionados }, () => {
      this.actualizarPedirPorDias(insumosConEseDia.map(({ idx }) => idx));
    });
  }

  confimacionGenerar(tipo) {
    this.formRef.current.validateFields().then((values) => {
      let proveedores = [];
      let cantidades = false;

      if (tipo === 1) {
        for (const valueInsumo of values.insumos) {
          const proveedor = proveedores.find((valueTodos) => valueTodos.toString() === valueInsumo.proveedorId?.toString());
          if (!proveedor && valueInsumo.pedir && valueInsumo?.pedir > 0) {
            cantidades = true;
            proveedores.push(valueInsumo.proveedorId.toString());
          }
        }
      } else if (tipo === 2) {
        for (const valueInsumo of values.insumosInteligente) {
          const proveedor = proveedores.find((valueTodos) => valueTodos.toString() === valueInsumo.proveedorId.toString());
          if (!proveedor && valueInsumo.pedir && valueInsumo?.pedir > 0) {
            cantidades = true;
            proveedores.push(valueInsumo.proveedorId.toString());
          }
        }
      } else if (tipo === 3) {
        for (const valueInsumo of values.insumosProveedorDefault) {
          const proveedor = proveedores.find((valueTodos) => valueTodos.toString() === valueInsumo.proveedorId.toString());
          if (!proveedor && valueInsumo.pedir && valueInsumo?.pedir > 0) {
            cantidades = true;
            proveedores.push(valueInsumo.proveedorId.toString());
          }
        }
      }

      if (!cantidades) return message.info('Agregue cantidades para generar las ordenes de compra');
      this.setState({ modalConfirmacion: true, valuesForm: values, numOrdenesAGenerar: proveedores.length, tipo });
    }).catch((e) => this.onFinishFailed(e));
  }

  onChangeProveedor(value, key) {
    const insumos = this.formRef.current.getFieldValue('insumos');
    const insumoArray = insumos[key];
    if (!insumoArray) return;

    const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoArray.insumoId.toString());
    if (!insumo) return;

    const buscarProveedor = this.state.todasProveedores.find(valueTP => valueTP._id.toString() === value.toString());
    let proveedorId = value;

    if (!buscarProveedor) {
      const buscarRelacion = insumo.relaciones.find(valueTR => valueTR._id.toString() === value.toString());
      if (!buscarRelacion) return;
      let arrayValue = [...insumos];
      arrayValue[key].insumoProveedorId = value;
      arrayValue[key].proveedorId = buscarRelacion.proveedorId;
      arrayValue[key].conversion = buscarRelacion.conversion;
      arrayValue[key].costo = buscarRelacion.costo;
      this.aplicarFila(key, arrayValue);
      proveedorId = buscarRelacion.proveedorId;
    }

    let relacionesObject = [], todasRelaciones = [];
    const objetoInsumosPInsumos = [...this.state.objetoInsumosPInsumos];
    const todasInsumosPInsumos = [...this.state.todasInsumosPInsumos];

    if (insumo?.relaciones && insumo?.relaciones?.length > 0) {
      for (const relacion of insumo.relaciones) {
        if (relacion.estado !== 0 && relacion.proveedorId.toString() === proveedorId.toString()) {
          relacionesObject.push(<Option value={relacion._id} key={relacion._id}>{relacion.descripcion + (relacion.costo ? (' ' + dineroDisabledMask(relacion.costo)) : '')}</Option>);
          todasRelaciones.push(relacion);
        }
      }
    }

    if (todasRelaciones.length === 1 && buscarProveedor) {
      let arrayValue = [...insumos];
      arrayValue[key].insumoProveedorId = todasRelaciones[0]._id ? todasRelaciones[0]._id : undefined;
      arrayValue[key].conversion = todasRelaciones[0].conversion;
      arrayValue[key].costo = todasRelaciones[0].costo;
      this.aplicarFila(key, arrayValue);
    }

    // Recalcular pedir si tiene días seleccionados (la conversión puede haber cambiado)
    const seleccionados = this.state.diasSeleccionados[key] || new Set();
    if (seleccionados.size > 0) {
      setTimeout(() => this.actualizarPedirPorDias(key), 50);
    }

    objetoInsumosPInsumos[key] = relacionesObject;
    todasInsumosPInsumos[key] = todasRelaciones;
    this.setState({ objetoInsumosPInsumos, todasInsumosPInsumos });
  }

  onChangeInsumoP(value, key) {
    let insumos = this.formRef.current.getFieldValue('insumos');
    const insumoArray = insumos[key];
    if (!insumoArray) return;
    const relacion = this.state.todasInsumosPInsumos[key].find(valueTR => valueTR._id.toString() === value.toString());
    if (!relacion) return;
    insumos[key].conversion = relacion.conversion;
    insumos[key].costo = relacion.costo;
    this.aplicarFila(key, insumos);
    // Recalcular pedir si tiene días seleccionados
    const seleccionados = this.state.diasSeleccionados[key] || new Set();
    if (seleccionados.size > 0) {
      setTimeout(() => this.actualizarPedirPorDias(key), 50);
    }
  }

  pedidoInteligente() {
    this.setState({ loadingPedidoInteligente: true });
    axios.post("requisiciones/pedidoInteligente", { requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          let insumosEditados = (res.data.insumosInteligente && res.data?.insumosInteligente?.length > 0)
            ? res.data.insumosInteligente.map(valueInsumo => {
              let insumoBuscar = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === valueInsumo.insumoId.toString());
              return { ...valueInsumo, descripcion: insumoBuscar ? insumoBuscar.descripcion : '', familiaNombre: insumoBuscar?.familia?.nombre ? insumoBuscar.familia.nombre : '', familiaId: insumoBuscar?.familiaId ? insumoBuscar.familiaId : '' };
            }).sort((a, b) => {
              let fc;
              if (a.familiaNombre && b.familiaNombre) fc = a.familiaNombre.localeCompare(b.familiaNombre);
              else if (a.familiaNombre) fc = -1;
              else if (b.familiaNombre) fc = 1;
              else fc = 0;
              if (fc !== 0) return fc;
              return a.descripcion.localeCompare(b.descripcion);
            }) : [];
          this.formRef.current.setFieldsValue({ insumosInteligente: insumosEditados });
          this.setState({ loadingPedidoInteligente: false, objetoInsumosPInsumos: insumosEditados.map(valueII => { const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === valueII.insumoId.toString()); if (!insumo) return null; let ro = []; if (insumo?.relaciones?.length > 0) { for (const r of insumo.relaciones) { if (r.estado !== 0 && r.proveedorId.toString() === valueII.proveedorId.toString()) ro.push(<Option value={r._id} key={r._id}>{r.descripcion + (r.costo ? (' ' + dineroDisabledMask(r.costo)) : '')}</Option>); } } return ro; }) });
          message.success("Se ha cargado el pedido inteligente");
        } else { this.setState({ loadingPedidoInteligente: false }); message.error("Hubo un error y no se cargo el pedido inteligente"); }
      });
  }

  pedirTotalesManual() {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos) return;
    const nuevosInsumosI = insumos.map(valueII => {
      if (valueII.proveedorId && valueII.insumoProveedorId) {
        const conversion = valueII?.conversion ? valueII.conversion : 1;
        const maximoConversion = calcularMaximoConversion(valueII.cantidad, valueII.cantidadOrdenada, conversion);
        return { ...valueII, pedir: maximoConversion };
      } else { return valueII; }
    });
    this.formRef.current.setFieldsValue({ insumos: nuevosInsumosI });
  }

  pedirTotalesInteligente() {
    const insumosInteligente = this.formRef.current.getFieldValue('insumosInteligente');
    if (!insumosInteligente) return;
    this.formRef.current.setFieldsValue({ insumosInteligente: insumosInteligente.map(v => ({ ...v, pedir: v.cantidad })) });
  }

  pedidoProveedorDefault() {
    this.setState({ loadingPedidoProveedorDefault: true });
    axios.post("requisiciones/pedidoProveedorDefault", { requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          let insumosEditados = (res.data.insumosProveedorDefault && res.data?.insumosProveedorDefault?.length > 0)
            ? res.data.insumosProveedorDefault.map(valueInsumo => { let ib = this.state.todasInsumos.find(v => v._id.toString() === valueInsumo.insumoId.toString()); return { ...valueInsumo, descripcion: ib ? ib.descripcion : '', familiaNombre: ib?.familia?.nombre ? ib.familia.nombre : '', familiaId: ib?.familiaId ? ib.familiaId : '' }; })
              .sort((a, b) => { let fc; if (a.familiaNombre && b.familiaNombre) fc = a.familiaNombre.localeCompare(b.familiaNombre); else if (a.familiaNombre) fc = -1; else if (b.familiaNombre) fc = 1; else fc = 0; if (fc !== 0) return fc; return a.descripcion.localeCompare(b.descripcion); }) : [];
          this.formRef.current.setFieldsValue({ insumosProveedorDefault: insumosEditados });
          this.setState({ loadingPedidoProveedorDefault: false, objetoInsumosPInsumos: insumosEditados.map(valueII => { const insumo = this.state.todasInsumos.find(v => v._id.toString() === valueII.insumoId.toString()); if (!insumo) return null; let ro = []; if (insumo?.relaciones?.length > 0) { for (const r of insumo.relaciones) { if (r.estado !== 0 && r.proveedorId.toString() === valueII.proveedorId.toString()) ro.push(<Option value={r._id} key={r._id}>{r.descripcion + (r.costo ? (' ' + dineroDisabledMask(r.costo)) : '')}</Option>); } } return ro; }) });
          message.success("Se ha cargado el pedido con proveedor default");
        } else { this.setState({ loadingPedidoProveedorDefault: false }); message.error("Hubo un error y no se cargo el pedido con proveedor default"); }
      });
  }

  calcularMejorPrecioManual() {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos) return;
    const objetoInsumosPInsumos = [...this.state.objetoInsumosPInsumos];
    const todasInsumosPInsumos = [...this.state.todasInsumosPInsumos];
    const nuevosInsumosI = insumos.map((valueII, indexII) => {
      const proveedores = this.state.objetoProveedoresPInsumos[indexII];
      if (!proveedores || proveedores?.length === 0) return valueII;
      let mejorPrecio = null, insumoProveedorId = null, proveedorId = null, conversion = null, costo = null;
      for (const proveedor of proveedores) { for (const relacion of proveedor.children) { const cu = relacion.costo / (relacion.conversion || 1); if (!mejorPrecio) { mejorPrecio = cu; insumoProveedorId = relacion.value; proveedorId = proveedor.value; conversion = relacion.conversion; costo = relacion.costo; } else if (cu < mejorPrecio) { mejorPrecio = cu; insumoProveedorId = relacion.value; proveedorId = proveedor.value; conversion = relacion.conversion; costo = relacion.costo; } } }
      if (mejorPrecio) {
        const bp = this.state.todasProveedores.find(v => v._id.toString() === proveedorId.toString());
        const insumo = this.state.todasInsumos.find(v => v._id.toString() === valueII.insumoId.toString());
        if (!insumo || !bp) return valueII;
        let ro = [], tr = [];
        if (insumo?.relaciones?.length > 0) { for (const r of insumo.relaciones) { if (r.estado !== 0 && r.proveedorId.toString() === proveedorId.toString()) { ro.push(<Option value={r._id} key={r._id}>{r.descripcion + (r.costo ? (' ' + dineroDisabledMask(r.costo)) : '')}</Option>); tr.push(r); } } }
        objetoInsumosPInsumos[indexII] = ro; todasInsumosPInsumos[indexII] = tr;
        return { ...valueII, insumoProveedorId, proveedorId, conversion, costo };
      } else { return valueII; }
    });
    this.setState({ objetoInsumosPInsumos, todasInsumosPInsumos });
    this.formRef.current.setFieldsValue({ insumos: nuevosInsumosI });
  }

  calcularMejorPrecioManualFamilia(familiaId) {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos) return;
    const objetoInsumosPInsumos = [...this.state.objetoInsumosPInsumos];
    const todasInsumosPInsumos = [...this.state.todasInsumosPInsumos];
    const nuevosInsumosI = insumos.map((valueII, indexII) => {
      if (valueII.familiaId !== familiaId) return valueII;
      const proveedores = this.state.objetoProveedoresPInsumos[indexII];
      if (!proveedores || proveedores?.length === 0) return valueII;
      let mejorPrecio = null, insumoProveedorId = null, proveedorId = null, conversion = null, costo = null;
      for (const proveedor of proveedores) { for (const relacion of proveedor.children) { const cu = relacion.costo / (relacion.conversion || 1); if (!mejorPrecio) { mejorPrecio = cu; insumoProveedorId = relacion.value; proveedorId = proveedor.value; conversion = relacion.conversion; costo = relacion.costo; } else if (cu < mejorPrecio) { mejorPrecio = cu; insumoProveedorId = relacion.value; proveedorId = proveedor.value; conversion = relacion.conversion; costo = relacion.costo; } } }
      if (mejorPrecio) {
        const bp = this.state.todasProveedores.find(v => v._id.toString() === proveedorId.toString());
        const insumo = this.state.todasInsumos.find(v => v._id.toString() === valueII.insumoId.toString());
        if (!insumo || !bp) return valueII;
        let ro = [], tr = [];
        if (insumo?.relaciones?.length > 0) { for (const r of insumo.relaciones) { if (r.estado !== 0 && r.proveedorId.toString() === proveedorId.toString()) { ro.push(<Option value={r._id} key={r._id}>{r.descripcion + (r.costo ? (' ' + dineroDisabledMask(r.costo)) : '')}</Option>); tr.push(r); } } }
        objetoInsumosPInsumos[indexII] = ro; todasInsumosPInsumos[indexII] = tr;
        return { ...valueII, insumoProveedorId, proveedorId, conversion, costo };
      } else { return valueII; }
    });
    this.setState({ objetoInsumosPInsumos, todasInsumosPInsumos });
    this.formRef.current.setFieldsValue({ insumos: nuevosInsumosI });
  }

  pedirTotalesManualFamilia(familiaId) {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos) return;
    const nuevosInsumosI = insumos.map(valueII => {
      if (valueII.familiaId !== familiaId) return valueII;
      if (valueII.proveedorId && valueII.insumoProveedorId) {
        const conversion = valueII?.conversion ? valueII.conversion : 1;
        const maximoConversion = calcularMaximoConversion(valueII.cantidad, valueII.cantidadOrdenada, conversion);
        return { ...valueII, pedir: maximoConversion };
      } else { return valueII; }
    });
    this.formRef.current.setFieldsValue({ insumos: nuevosInsumosI });
  }

  pedirTotalesDefault() {
    const i = this.formRef.current.getFieldValue('insumosProveedorDefault');
    if (!i) return;
    this.formRef.current.setFieldsValue({ insumosProveedorDefault: i.map(v => ({ ...v, pedir: v.cantidad })) });
  }

  pedirTotalesDefaultFamilia(familiaId) {
    const i = this.formRef.current.getFieldValue('insumosProveedorDefault');
    if (!i) return;
    this.formRef.current.setFieldsValue({ insumosProveedorDefault: i.map(v => v.familiaId !== familiaId ? v : { ...v, pedir: v.cantidad }) });
  }

  pedirTotalesInteligenteFamilia(familiaId) {
    const i = this.formRef.current.getFieldValue('insumosInteligente');
    if (!i) return;
    this.formRef.current.setFieldsValue({ insumosInteligente: i.map(v => v.familiaId !== familiaId ? v : { ...v, pedir: v.cantidad }) });
  }

  generarOrdenManual(values) {
    let pasar = false;
    for (const v of values.insumos) { if (v.cantidad && v.proveedorId && v.insumoProveedorId && v.pedir && v.pedir > 0) { pasar = true; break; } }
    if (!pasar) return message.info('Selecciona los proveedores de los insumos que requieres');
    this.setState({ loading: true });
    const { separarDias, diasSeleccionados } = this.state;
    const insumosConDias = values.insumos.map((ins, idx) => {
      const sel = diasSeleccionados[idx] ? Array.from(diasSeleccionados[idx]) : [];
      return { ...ins, diasSeleccionados: sel };
    });
    axios.post("requisiciones/generarOrdenesDeCompra", { ...values, insumos: insumosConDias, separarDias, requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { this.setState({ loading: false }); if (res.data.success === 2) { message.success("Se han generado las ordenes de compra"); this.formRef.current.resetFields(); this.atras(); } else { message.error("Hubo un error y no se generaron las ordenes de compra"); } });
  }

  generarOrdenInteligente(values) {
    for (const v of values.insumosInteligente) { if (v.cantidad && !v.proveedorId) return message.info('Selecciona los proveedores de los insumos que requieres'); }
    this.setState({ loading: true });
    axios.post("requisiciones/generarOrdenesDeCompraInteligente", { ...values, insumos: values.insumosInteligente, requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { this.setState({ loading: false }); if (res.data.success === 2) { message.success("Se han generado las ordenes de compra"); this.formRef.current.resetFields(); this.atras(); } else { message.error("Hubo un error y no se generaron las ordenes de compra"); } });
  }

  generarOrdenDefault(values) {
    for (const v of values.insumosProveedorDefault) { if (v.cantidad && !v.proveedorId) return message.info('Selecciona los proveedores de los insumos que requieres'); }
    this.setState({ loading: true });
    axios.post("requisiciones/generarOrdenesDeCompraProveedorDefault", { ...values, insumos: values.insumosProveedorDefault, requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { this.setState({ loading: false }); if (res.data.success === 2) { message.success("Se han generado las ordenes de compra"); this.formRef.current.resetFields(); this.atras(); } else { message.error("Hubo un error y no se generaron las ordenes de compra"); } });
  }

  asignarProveedor(key) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const arrayValue = insumos[key];
    if (!arrayValue) return;
    if (!arrayValue.insumoId) { message.error("Selecciona un insumo primero"); return; }
    this.setState({ modalAsignarProveedor: true, modalAsignarProveedorInsumoId: arrayValue.insumoId, modalAsignarProveedorKey: key });
  }

  async cerrarAsignarProveedor(nuevoInsumo) {
    if (nuevoInsumo) {
      const todasInsumos = [...this.state.todasInsumos];
      const idx = todasInsumos.findIndex(i => i._id === nuevoInsumo._id);
      if (idx !== -1) todasInsumos[idx] = nuevoInsumo;
      await this.setState({ todasInsumos });
      this.consultarTodo(true, this.state.modalAsignarProveedorKey, nuevoInsumo);
    }
    this.setState({ modalAsignarProveedor: false, modalAsignarProveedorInsumoId: null, modalAsignarProveedorKey: null });
  }

  agregarAOrdenDeCompraExistente() {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const filtrados = insumos.filter(v => v.pedir && v.pedir > 0);
    let diferenteProveedor = false, proveedorId = null, pasar = false, diferente = false;
    for (const v of filtrados) {
      if (!proveedorId && v.proveedorId) proveedorId = v.proveedorId.toString();
      else if (proveedorId && v.proveedorId && proveedorId !== v.proveedorId.toString()) { diferenteProveedor = true; break; }
      if (v.cantidad && v.proveedorId && v.insumoProveedorId && v.pedir && v.pedir > 0) pasar = true;
      if (v.pedir && v.pedir > 0 && (!v.proveedorId || !v.insumoProveedorId)) diferente = true;
    }
    if (!pasar || diferente) return message.info('Selecciona los proveedores de los insumos que requieres');
    if (diferenteProveedor) return message.info('Los insumos seleccionados tienen diferentes proveedores');
    this.setState({ modalAgregarAOrdenDeCompraExistente: true, modalAgregarAOrdenDeCompraExistenteInsumos: filtrados, modalAgregarAOrdenDeCompraExistenteProveedorId: proveedorId });
  }

  onCancelModalAgregarInsumosAExistente() {
    this.setState({ modalAgregarAOrdenDeCompraExistente: false, modalAgregarAOrdenDeCompraExistenteInsumos: [], modalAgregarAOrdenDeCompraExistenteProveedorId: null });
  }

  onConfirmModalAgregarInsumosAExistente(ordenId) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const filtrados = insumos.filter(v => v.pedir && v.pedir > 0);
    if (filtrados.length === 0) return message.info('No hay insumos para agregar');
    let diferenteProveedor = false, proveedorId = null, pasar = false;
    for (const v of filtrados) {
      if (!proveedorId && v.proveedorId) proveedorId = v.proveedorId.toString();
      else if (proveedorId && v.proveedorId && proveedorId !== v.proveedorId.toString()) { diferenteProveedor = true; break; }
      if (v.cantidad && v.proveedorId && v.insumoProveedorId && v.pedir && v.pedir > 0) { pasar = true; break; }
    }
    if (!pasar) return message.info('Selecciona los proveedores de los insumos que requieres');
    if (diferenteProveedor) return message.info('Los insumos seleccionados tienen diferentes proveedores');
    this.setState({ loading: true, modalAgregarAOrdenDeCompraExistente: false, modalAgregarAOrdenDeCompraExistenteInsumos: [], modalAgregarAOrdenDeCompraExistenteProveedorId: null });
    axios.post("requisiciones/agregarInsumosAOrdenDeCompraExistente", { insumos: filtrados, ordenId, requisicionId: this.props.location.state.id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { this.setState({ loading: false }); if (res.data.success === 2) { message.success("Se han agregado los insumos a la orden de compra"); this.formRef.current.resetFields(); this.atras(); } else { message.error(res.data.message || "Hubo un error"); } });
  }

  obtenerColorTagRequisicion = (importancia) => {
    switch (importancia) { case 3: return "red"; case 2: return "orange"; case 1: return "green"; default: return "blue"; }
  };

  verRequisicionModal(id) { this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id }); }
  cerrarModalVerRequisicion() { this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null }); }

  abrirObservaciones(value, observaciones, insumoId) {
    const insumo = this.state.todasInsumos.find(v => v._id.toString() === insumoId.toString());
    this.setState({ modalObservaciones: true, modalObservacionesIndex: value, modalObservacionesObservaciones: observaciones, modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas });
  }

  cerrarObservaciones(value) {
    const indice = this.state.modalObservacionesIndex;
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[indice].observaciones = value;
    this.aplicarFila(indice, insumos);
    this.setState({ modalObservaciones: false, modalObservacionesIndex: null, modalObservacionesObservaciones: null, modalObservacionesObservacionesPasadas: null });
  }

  buscarInsumo = (valor) => {
    this.setState({ busquedaInsumo: valor, insumoResaltado: null });
    if (!valor) return;

    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    
    const index = insumos.findIndex((insumo) => {
      // Aquí buscamos la info completa en la lista maestra
      const infoInsumo = this.state.todasInsumos.find(i => i._id === insumo.insumoId);
      if (!infoInsumo) return false;
      
      return (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        String(infoInsumo.codigo || "").toLowerCase().includes(texto) ||
        String(infoInsumo.clave || "").toLowerCase().includes(texto) ||
        String(infoInsumo.codigoBarras || "").toLowerCase().includes(texto)
      );
    });

    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }

    this.setState({ insumoResaltado: index });

    const fila = document.getElementById(`insumo-row-${index}`);
    if (fila) {
      fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  toggleVerInventario = async (checked) => {
    if (!checked) {
      this.setState({ verInventario: false, inventarioData: {} });
      return;
    }
    const insumos = this.formRef.current.getFieldValue('insumos') || [];
    const proyectoId = this.formRef.current.getFieldValue('proyectoId');
    const insumosReq = insumos.map((valueInsumo, index) => {
      const insumo = this.state.todasInsumos.find(i => i._id === valueInsumo.insumoId);
      return {
        index,
        insumoId: valueInsumo.insumoId,
        inventariable: !!insumo?.inventariable,
        insumoCompuesto: !!insumo?.insumoCompuesto,
        noPrincipal: !!insumo?.noPrincipal,
      };
    }).filter(i => i.insumoId);

    if (insumosReq.length === 0) {
      this.setState({ verInventario: true });
      return;
    }
    this.setState({ loadingInventario: true, verInventario: true });
    try {
      const res = await axios.post(
        'inventarios/inventarioInsumoProyectoBulk',
        { proyectoId, empresaId: this.props.empresaId, insumos: insumosReq },
        { headers: this.props.headersToken }
      );
      const inventarioData = {};
      if (res.data.results) {
        res.data.results.forEach(r => {
          inventarioData[r.index] = r.tipo === 'NO_INVENTARIABLE' ? 'N/A' : r.cantidad;
        });
      }
      this.setState({ inventarioData, loadingInventario: false });
    } catch {
      this.setState({ loadingInventario: false });
      message.error('Error al consultar el inventario');
    }
  };

  abrirConfirmarConsultarPrecios = () => {
    this.setState({ modalConfirmarConsultarPrecios: true });
  };

  iniciarConsultaPrecios = async () => {
    this.setState({
      modalConfirmarConsultarPrecios: false,
      loadingConsultarPrecios: true,
      modalConsultarPrecios: true,
      progresoConsulta: [],
    });

    const handleWS = (event) => {
      let msg;
      try {
        msg = JSON.parse(event.data);
      } catch {
        return;
      }
      if (msg.type !== "scraping_progreso") return;
      this.setState((prev) => {
        const existe = prev.progresoConsulta.find((p) => p.tipo === msg.tipo);
        const total = msg.total ?? prev.totalProgreso;
        const completados = msg.completados ?? prev.completadosProgreso;
        let progresoConsulta;
        if (msg.estado === "scrapeando") {
          progresoConsulta = existe
            ? prev.progresoConsulta.map((p) =>
                p.tipo === msg.tipo
                  ? {
                      ...p,
                      estado: "scrapeando",
                      porcentaje: msg.porcentaje,
                      terminoActual: msg.terminoActual,
                      terminosCompletados: msg.terminosCompletados,
                      terminosTotal: msg.terminosTotal,
                    }
                  : p
              )
            : [
                ...prev.progresoConsulta,
                {
                  nombre: msg.proveedorNombre,
                  tipo: msg.tipo,
                  estado: "scrapeando",
                  porcentaje: msg.porcentaje,
                  terminoActual: msg.terminoActual,
                  terminosCompletados: msg.terminosCompletados,
                  terminosTotal: msg.terminosTotal,
                },
              ];
        } else if (msg.estado === "ok") {
          progresoConsulta = existe
            ? prev.progresoConsulta.map((p) =>
                p.tipo === msg.tipo
                  ? { ...p, estado: "ok", porcentaje: 100, terminoActual: undefined }
                  : p
              )
            : [
                ...prev.progresoConsulta,
                {
                  nombre: msg.proveedorNombre,
                  tipo: msg.tipo,
                  estado: "ok",
                  porcentaje: 100,
                },
              ];
        } else {
          // "consultando" o cualquier otro estado inicial
          progresoConsulta = existe
            ? prev.progresoConsulta.map((p) =>
                p.tipo === msg.tipo ? { ...p, estado: msg.estado } : p
              )
            : [
                ...prev.progresoConsulta,
                {
                  nombre: msg.proveedorNombre,
                  tipo: msg.tipo,
                  estado: msg.estado,
                  porcentaje: 0,
                },
              ];
        }
        return {
          progresoConsulta,
          totalProgreso: total,
          completadosProgreso: completados,
        };
      });
    };

    const ws = window.appSocket;
    if (ws) ws.addEventListener("message", handleWS);

    try {
      const res = await axios.post(
        "preciosProveedor/consultarPreciosRequisicion",
        { requisicionId: this.props.location.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken, timeout: 0 }
      );
      if (ws) ws.removeEventListener("message", handleWS);
      if (res.data?.success === 0) {
        message.error(res.data?.err || "No se pudieron consultar los precios online");
        this.setState({ loadingConsultarPrecios: false, modalConsultarPrecios: false });
      } else if (res.data?.success === 2 || res.data?.success === 1) {
        if (res.data.success === 1) {
          message.warning(
            res.data?.err ||
              "Algunos proveedores fallaron. Se muestran únicamente los que respondieron."
          );
        }
        this.setState({
          consultarPreciosData: {
            proveedores: res.data.proveedores || [],
            insumos: res.data.insumos || [],
          },
          loadingConsultarPrecios: false,
        });
      } else {
        message.error(res.data?.err || "No se pudieron consultar los precios online");
        this.setState({ loadingConsultarPrecios: false, modalConsultarPrecios: false });
      }
    } catch (e) {
      if (ws) ws.removeEventListener("message", handleWS);
      message.error("Error al consultar los precios online");
      this.setState({ loadingConsultarPrecios: false, modalConsultarPrecios: false });
    }
  };

  cerrarConsultaPrecios = () => {
    this.setState({
      modalConsultarPrecios: false,
      consultarPreciosData: null,
      proveedoresAsignadosScrap: {},
      relacionesAsignadasScrap: {},
      progresoConsulta: [],
      totalProgreso: undefined,
      completadosProgreso: undefined,
    });
  };

  seleccionarProveedorScrap = (insumoId, proveedorId, terminoUsado, cantidadDisponible) => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const idx = insumos.findIndex((v) => v.insumoId && v.insumoId.toString() === insumoId.toString());
    if (idx === -1) {
      message.warning("El insumo ya no está en la orden");
      return;
    }
    const key = insumoId.toString();
    const norm = (v) => (v || "").toString().trim().toLowerCase();
    const termClicked = terminoUsado ? terminoUsado.toString() : null;
    const provActual = this.state.proveedoresAsignadosScrap[key];
    const termActual = this.state.relacionesAsignadasScrap[key];
    // Toggle: si re-clickas el mismo (proveedor + término), deselecciona
    const mismoProveedor = provActual === proveedorId.toString();
    const mismoTermino = termClicked
      ? norm(termActual) === norm(termClicked)
      : !termActual;
    if (mismoProveedor && mismoTermino) {
      const arrayValueClear = [...insumos];
      arrayValueClear[idx] = {
        ...arrayValueClear[idx],
        proveedorId: undefined,
        insumoProveedorId: undefined,
        conversion: undefined,
        costo: undefined,
        pedir: undefined,
      };
      this.formRef.current.setFieldsValue({ insumos: arrayValueClear });
      const objetoInsumosPInsumosClear = [...this.state.objetoInsumosPInsumos];
      const todasInsumosPInsumosClear = [...this.state.todasInsumosPInsumos];
      objetoInsumosPInsumosClear[idx] = [];
      todasInsumosPInsumosClear[idx] = [];
      const nuevoProveedores = { ...this.state.proveedoresAsignadosScrap };
      const nuevoRelaciones = { ...this.state.relacionesAsignadasScrap };
      delete nuevoProveedores[key];
      delete nuevoRelaciones[key];
      this.setState({
        objetoInsumosPInsumos: objetoInsumosPInsumosClear,
        todasInsumosPInsumos: todasInsumosPInsumosClear,
        proveedoresAsignadosScrap: nuevoProveedores,
        relacionesAsignadasScrap: nuevoRelaciones,
      });
      const seleccionadosToggle = this.state.diasSeleccionados[idx] || new Set();
      if (seleccionadosToggle.size > 0) {
        setTimeout(() => this.actualizarPedirPorDias(idx), 50);
      }
      message.info("Proveedor deseleccionado");
      return;
    }
    const insumo = this.state.todasInsumos.find((v) => v._id.toString() === insumoId.toString());
    const proveedor = this.state.todasProveedores.find((v) => v._id.toString() === proveedorId.toString());
    if (!insumo || !proveedor) {
      message.warning("No se encontró el proveedor o el insumo");
      return;
    }
    const relacionesActivas = (insumo.relaciones || []).filter(
      (r) => r.estado !== 0 && r.proveedorId.toString() === proveedorId.toString()
    );
    if (relacionesActivas.length === 0) {
      message.warning("Este proveedor no está dado de alta para el insumo. Use 'Asig.' para crearlo.");
      return;
    }
    // Si el back nos dio el término usado, escogemos esa relación; si no, la de menor costo unitario.
    let mejorRelacion = null;
    if (termClicked) {
      mejorRelacion = relacionesActivas.find((r) => norm(r.descripcion) === norm(termClicked));
    }
    if (!mejorRelacion) {
      mejorRelacion = relacionesActivas[0];
      let mejorCU = mejorRelacion.costo / (mejorRelacion.conversion || 1);
      for (const r of relacionesActivas) {
        const cu = r.costo / (r.conversion || 1);
        if (cu < mejorCU) {
          mejorCU = cu;
          mejorRelacion = r;
        }
      }
    }
    // Construir las Options de relaciones para el SelectItem de Insumo Proveedor
    const objetoInsumosPInsumos = [...this.state.objetoInsumosPInsumos];
    const todasInsumosPInsumos = [...this.state.todasInsumosPInsumos];
    const ro = [];
    const tr = [];
    for (const r of relacionesActivas) {
      ro.push(
        <Option value={r._id} key={r._id}>
          {r.descripcion + (r.costo ? " " + dineroDisabledMask(r.costo) : "")}
        </Option>
      );
      tr.push(r);
    }
    objetoInsumosPInsumos[idx] = ro;
    todasInsumosPInsumos[idx] = tr;
    // Cantidad a pedir: prefiere cantidadRequerida del backend; cae a cantidad - cantidadOrdenada del form.
    // Si NO viene cantidadDisponible (solo trae "disponible: true"), pedimos la cantidad total requerida.
    // Si SÍ viene cantidadDisponible (incluyendo 0), pedimos min(disponible, requerido).
    const filaActual = insumos[idx] || {};
    const insumoScrap = this.state.consultarPreciosData?.insumos?.find(
      (i) => i?.insumoId?.toString() === insumoId.toString()
    );
    const toPosNum = (v) => {
      const n = Number(v);
      return !isNaN(n) && n > 0 ? n : null;
    };
    const requeridoBack = toPosNum(insumoScrap?.cantidadRequerida);
    const cantidadForm =
      toPosNum(filaActual.cantidad) ?? toPosNum(filaActual.cantidadInsumo) ?? 0;
    const ordenadaForm = Number(filaActual.cantidadOrdenada) || 0;
    const restanteForm = Math.max(0, cantidadForm - ordenadaForm);
    const restantePz = requeridoBack ?? restanteForm;
    const dispRaw = Number(cantidadDisponible);
    const dispProvided = typeof cantidadDisponible !== "undefined" && cantidadDisponible !== null && !isNaN(dispRaw);
    let pedirCalc;
    if (dispProvided) {
      pedirCalc = restantePz > 0 ? Math.min(dispRaw, restantePz) : dispRaw;
    } else if (restantePz > 0) {
      pedirCalc = restantePz;
    }
    // Escribir proveedor + relacion al form
    const arrayValue = [...insumos];
    arrayValue[idx] = {
      ...arrayValue[idx],
      proveedorId,
      insumoProveedorId: mejorRelacion._id,
      conversion: mejorRelacion.conversion,
      costo: mejorRelacion.costo,
      ...(typeof pedirCalc === "number" ? { pedir: pedirCalc } : {}),
    };
    this.formRef.current.setFieldsValue({ insumos: arrayValue });
    // Guardamos el término clickeado (lo que viene del backend), para que la UI lo señale
    // aunque el descripcion local sea ligeramente distinto (mayúsculas, espacios, etc.).
    const terminoParaUI = termClicked || mejorRelacion.descripcion || null;
    this.setState({
      objetoInsumosPInsumos,
      todasInsumosPInsumos,
      proveedoresAsignadosScrap: {
        ...this.state.proveedoresAsignadosScrap,
        [key]: proveedorId.toString(),
      },
      relacionesAsignadasScrap: {
        ...this.state.relacionesAsignadasScrap,
        [key]: terminoParaUI,
      },
    });
    // Recalcular pedir si tiene días seleccionados (la conversión puede haber cambiado)
    const seleccionados = this.state.diasSeleccionados[idx] || new Set();
    if (seleccionados.size > 0) {
      setTimeout(() => this.actualizarPedirPorDias(idx), 50);
    }
    message.success("Proveedor asignado al insumo");
  };

  renderCeldaScrap = (celda, requerido) => {
    if (!celda) return <span style={{ color: "#bfbfbf" }}>—</span>;
    if (celda.error) return <span style={{ color: "#bfbfbf", fontSize: 11 }}>Sin resultados</span>;
    const parts = [];
    if (celda.precio !== undefined && celda.precio !== null && !isNaN(celda.precio)) {
      parts.push(
        <div key="p" style={{ fontWeight: 700, color: "#0050b3" }}>
          {dineroDisabledMask(round2Decimals(celda.precio))}
        </div>
      );
    }
    if (celda.cantidadDisponible !== undefined && celda.cantidadDisponible !== null) {
      const disp = celda.cantidadDisponible;
      const tieneRequerido = typeof requerido === "number" && requerido > 0;
      let color = "#52c41a";
      if (disp <= 0) color = "#ff4d4f";
      else if (tieneRequerido && disp < requerido) color = "#fa8c16";
      const insuficiente = tieneRequerido && disp > 0 && disp < requerido;
      parts.push(
        <div key="c" style={{ fontSize: 11, color, fontWeight: insuficiente ? 700 : 400 }}>
          {disp} pzs
          {insuficiente && (
            <div style={{ fontSize: 9, color: "#fa8c16", marginTop: 1 }}>
              Faltan {requerido - disp}
            </div>
          )}
        </div>
      );
    } else if (celda.disponible === true) {
      parts.push(
        <div key="d" style={{ fontSize: 11, color: "#52c41a" }}>✓ Disponible</div>
      );
    } else if (celda.disponible === false) {
      parts.push(
        <div key="d" style={{ fontSize: 11, color: "#ff4d4f" }}>✗ Agotado</div>
      );
    }
    if (parts.length === 0) return <span style={{ color: "#bfbfbf" }}>—</span>;
    return <div style={{ textAlign: "center" }}>{parts}</div>;
  };

  render() {
    let familiaAnteriorId, familiaAnteriorInteligenteId, familiaAnteriorDefaultId;
    const isMobile = window.innerWidth <= 1000;
    const { separarDias, diasSeleccionados } = this.state;

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Generar Orden De Compra " + (this.state.workbench ? "Workbench # " : "Requisicion # ") + this.state.numeroRequisicion}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form ref={this.formRef} name="generarOrdenDeCompraConRequisicion" layout onFinishFailed={this.onFinishFailed}>
              <GeneralFormLayout
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 12,
                    xl: 12,
                    content: (
                      <>
                        <FormItem label="Fecha Solicitud" name="fechaSolicitud" margin><DatePickerItem disabled placeholder="Fecha de Solicitud" /></FormItem>
                        <FormItem label="Fecha Entrega" name="fechaEntrega" margin><DatePickerItem disabled placeholder="Fecha de Entrega" /></FormItem>
                        <FormItem label="Solicitante" name="solicitanteId" tooltip="Usuario que solicita la requisición" margin>
                          <SelectItem disabled placeholder="Seleeccione a quién se le asignará la requisición">{this.state.objetoUsuarios}</SelectItem>
                        </FormItem>
                        <FormItem label="Proyecto" name="proyectoId" margin required>
                          <SelectItem disabled placeholder="Proyecto">{this.state.objetoProyectos}</SelectItem>
                        </FormItem>
                      </>
                    ),
                  },
                  {
                    title: "Extras",
                    lg: 12,
                    xl: 12,
                    content: (
                      <>
                        <FormItem label="Separar Ins:" name="separarInsumos" margin initialValue={false} valuePropName="checked" tooltip="¿Separar insumos en la orden de compra?" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}><SwitchItem disabled /></FormItem>
                        <FormItem label="Importancia" name="importancia" tooltip="Nivel de importancia" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                          <SelectItem placeholder="Seleccione nivel de importancia" disabled style={{ width: "100%" }}>
                            <Option value={1}><Tag color="green" style={{ marginRight: 8 }}><ArrowUpOutlined /> Baja</Tag></Option>
                            <Option value={2}><Tag color="orange" style={{ marginRight: 8 }}><WarningOutlined /> Media</Tag></Option>
                            <Option value={3}><Tag color="red" style={{ marginRight: 8 }}><FireOutlined /> Alta</Tag></Option>
                          </SelectItem>
                        </FormItem>
                        {this.state.workbench && (
                          <FormItem label="Prov." name="proveedorId" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                            <SelectProveedoresItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde autoFocus disabled dropdownMatchSelectWidth={600} width="100%" placeholder="Proveedor" />
                          </FormItem>
                        )}
                        <FormItem label="Observaciones" name="observaciones" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern>
                          <TextAreaItem disabled placeholder="Observaciones" />
                        </FormItem>
                      </>
                    ),
                  },
                ]}
              />

              <FormItem noStyle shouldUpdate={(p, c) => p.proyectoId !== c.proyectoId}>
                {({ getFieldValue }) => {
                  let proyectoId = getFieldValue("proyectoId");
                  if (!proyectoId) return null;
                  let proyecto = this.state.todasProyectos?.find(v => v._id === proyectoId);
                  if (!proyecto) return null;
                  return (
                    <div style={{ padding: "0 16px", marginBottom: 16 }}>
                      <Row>
                        <InfoCard
                          title="PROYECTO"
                          icon={<InfoCircleOutlined />}
                          accentColor="#00BFD6"
                          compact
                          sections={[
                            {
                              title: "Información General",
                              icon: <InfoCircleOutlined />,
                              iconColor: "#00BFD6",
                              lg: 8,
                              items: [
                                { label: "Nombre", value: proyecto.nombre || "-" },
                                { label: "Descripción", value: proyecto.descripcion || "-" },
                              ],
                            },
                            {
                              title: proyecto.calle ? "Dirección" : "Vehículo",
                              icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                              iconColor: "#C9DF00",
                              lg: 8,
                              items: proyecto.calle
                                ? [
                                  { label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` },
                                ]
                                : [
                                  { label: "Marca", value: proyecto.marca || "-" },
                                  { label: "Modelo", value: proyecto.modelo || "-" },
                                  { label: "Placas", value: proyecto.placas || "-" },
                                ],
                            },
                            {
                              title: "Detalles",
                              icon: <CarOutlined />,
                              iconColor: "#FF6A0D",
                              lg: 8,
                              items: [
                                { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                                { label: "ID", value: proyecto._id?.slice(-6).toUpperCase() || "—" },
                              ],
                            },
                          ]}
                        />
                      </Row>
                    </div>
                  );
                }}
              </FormItem>

              <div style={{ padding: "0 16px" }}>
                <style>{tabStyles}</style>
                <div style={{ maxWidth: "100%", width: "100%", margin: "0 auto", position: "relative" }}>
                <Tabs
                  className="custom-tabs"
                  tabBarStyle={{ background: "transparent", margin: 0, padding: "0 16px", minHeight: "auto" }}
                  onTabClick={(key) => { this.setState({ activeTab: key }); if (key === '2') this.pedidoInteligente(); if (key === '3') this.pedidoProveedorDefault(); }}
                  >

                  {/* ─────────────── TAB MANUAL ─────────────── */}
                  <TabPane tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Manual</span>} key='1' forceRender>
                    <Spin spinning={false}>
                      <Row justify="end" align="middle" style={{ marginBottom: 8 }} gutter={[10, 10]}>
                        <Space wrap>
                          {this.props.consultarProveedoresOnline && (
                            <Tooltip title="Consulta precios y disponibilidad en los portales de los proveedores. Puede tardar varios minutos.">
                              <ButtonItem
                                type="primary"
                                icon={<GlobalOutlined />}
                                onClick={this.abrirConfirmarConsultarPrecios}
                                loading={this.state.loadingConsultarPrecios}
                              >
                                Consultar precios online
                              </ButtonItem>
                            </Tooltip>
                          )}
                          <Input.Search
                            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                            placeholder="Buscar por descripción, código, clave o cód. barras..."
                            allowClear
                            enterButton={
                              <Button
                                type="primary"
                                style={{
                                  background: "#00BFD6",
                                  borderColor: "#00BFD6"
                                }}
                              >
                                Buscar
                              </Button>
                            }
                            size="middle"
                            onSearch={this.buscarInsumo}
                            onChange={(e) => {
                              if (!e.target.value) this.setState({ insumoResaltado: null });
                            }}
                            style={{
                              borderRadius: 8,
                              width: '30vw',
                              minWidth: 300
                            }}
                          />
                          <span style={{ fontSize: 13 }}>Ver Inventario:</span>
                          <Switch checked={this.state.verInventario} loading={this.state.loadingInventario} onChange={this.toggleVerInventario} />
                        </Space>
                      </Row>
                      <FormInitial.List name="insumos">
                        {(fields) => (
                          <div className="tabla-insumos-venta tabla-fija-compacta" style={{ overflowX: isMobile ? 'auto' : 'visible' }}>
                            <table className="table table-12px" style={{ minWidth: isMobile ? "900px" : 0, backgroundColor: "white" }}>
                              {fields.length > 0 ? (
                                <thead>
                                  <tr>
                                    <th className="th-border" style={{ width: "5%" }}>#</th>
                                    <th className="th-border" style={{ width: "16%" }}>Insumo</th>
                                    <th className="th-border" style={{ width: "8%" }}>Unidad</th>
                                    <th className="th-border" style={{ width: "8%" }}>Cantidad</th>
                                    <th className="th-border" style={{ width: "8%" }}>Ord.</th>
                                    <th className="th-border" style={{ width: "8%" }}>Req.</th>
                                    <th className="th-border" style={{ width: "10%" }}>Entrega</th>
                                    <th className="th-border" style={{ width: "12%" }}>
                                      Proveedor
                                      <Tooltip title='Mejor Precio'><CalculatorOutlined onClick={() => this.calcularMejorPrecioManual()} style={{ marginLeft: '5px', color: '#00b5e2' }} /></Tooltip>
                                    </th>
                                    <th className="th-border" style={{ width: "12%" }}>Insumo Proveedor</th>
                                    <th className="th-border" style={{ width: "15%" }}>Costo</th>
                                    <th className="th-border" style={{ width: "10%" }}>Conv.</th>
                                    {this.state.verInventario && (
                                      <th className="th-border" style={{ width: "10%" }}>Inventario</th>
                                    )}
                                    <th className="th-border" style={{ width: "10%" }}>
                                      Cantidad A Pedir
                                      <Tooltip title='Totales'><CalculatorOutlined onClick={() => this.pedirTotalesManual()} style={{ marginLeft: '5px', color: '#00b5e2' }} /></Tooltip>
                                    </th>
                                    <th className="th-border" style={{ width: "10%" }}>Acción</th>
                                  </tr>
                                  {/* ── Fila de chips globales por día (solo si separarDias) ── */}
                                  {separarDias && (() => {
                                    const todosInsumos = this.formRef.current.getFieldValue('insumos') || [];
                                    const fechaEntregaGlobal = this.formRef.current.getFieldValue('fechaEntrega');
                                    // Un solo recorrido sobre los insumos para los 7 días: antes
                                    // eran 2 reduce por día (14 pasadas sobre N) en cada render
                                    // del encabezado.
                                    const resumenPorDia = {};
                                    for (const dia of DIAS_SEMANA) resumenPorDia[dia.key] = { total: 0, idxConDia: [] };
                                    todosInsumos.forEach((ins, i) => {
                                      for (const dia of DIAS_SEMANA) {
                                        const cantidadDia = Number(ins.cantidadPorDia?.[dia.key]) || 0;
                                        if (!cantidadDia) continue;
                                        resumenPorDia[dia.key].total += cantidadDia;
                                        resumenPorDia[dia.key].idxConDia.push(i);
                                      }
                                    });
                                    return (
                                      <tr>
                                        <th
                                          colSpan={13 + (this.state.verInventario ? 1 : 0)}
                                          className="th-border"
                                          style={{ backgroundColor: "#e6f7ff", padding: "6px 10px", fontWeight: "normal" }}
                                        >
                                          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#1890ff", marginRight: 4, whiteSpace: "nowrap" }}>
                                              📅 Pedir por día (todos):
                                            </span>
                                            {DIAS_SEMANA.map((dia, idxDia) => {
                                              const fechaDiaGlobal = fechaEntregaGlobal ? moment(fechaEntregaGlobal).add(idxDia, "days") : null;
                                              // Suma total de ese día y los índices de los insumos
                                              // que lo tienen: ya calculados en la pasada única.
                                              const { total: totalDiaGlobal, idxConDia } = resumenPorDia[dia.key];
                                              const todosSelGlobalCorrecto = idxConDia.length > 0 && idxConDia.every(i => (diasSeleccionados[i] || new Set()).has(dia.key));
                                              const sinCantidadGlobal = totalDiaGlobal === 0;

                                              return (
                                                <Tooltip
                                                  key={dia.key}
                                                  title={
                                                    sinCantidadGlobal
                                                      ? `${dia.label}: ningún insumo tiene cantidad`
                                                      : todosSelGlobalCorrecto
                                                        ? `Deseleccionar ${dia.label} en todos (${totalDiaGlobal})`
                                                        : `Seleccionar ${dia.label} en todos los insumos (${totalDiaGlobal})`
                                                  }
                                                >
                                                  <div
                                                    onClick={() => !sinCantidadGlobal && this.toggleDiaGlobal(dia.key)}
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "center",
                                                      minWidth: 52,
                                                      padding: "3px 6px",
                                                      background: sinCantidadGlobal
                                                        ? "#f5f5f5"
                                                        : todosSelGlobalCorrecto
                                                          ? "#1890ff"
                                                          : "#e6f7ff",
                                                      border: `2px solid ${sinCantidadGlobal ? "#d9d9d9" : todosSelGlobalCorrecto ? "#096dd9" : "#91d5ff"}`,
                                                      borderRadius: 6,
                                                      cursor: sinCantidadGlobal ? "default" : "pointer",
                                                      opacity: sinCantidadGlobal ? 0.4 : 1,
                                                      userSelect: "none",
                                                      transition: "all 0.15s",
                                                    }}
                                                  >
                                                    <span style={{
                                                      fontSize: 10, fontWeight: 700,
                                                      color: sinCantidadGlobal ? "#bfbfbf" : todosSelGlobalCorrecto ? "#fff" : "#1890ff",
                                                      lineHeight: 1, marginBottom: 1,
                                                    }}>
                                                      {dia.label}
                                                      {fechaDiaGlobal && (
                                                        <span style={{ fontWeight: 400, marginLeft: 3, opacity: 0.85 }}>
                                                          {fechaDiaGlobal.format("DD")}
                                                        </span>
                                                      )}
                                                    </span>
                                                    <span style={{
                                                      fontSize: 13, fontWeight: 700,
                                                      color: sinCantidadGlobal ? "#bfbfbf" : todosSelGlobalCorrecto ? "#fff" : "#1890ff",
                                                    }}>
                                                      {totalDiaGlobal || "-"}
                                                    </span>
                                                  </div>
                                                </Tooltip>
                                              );
                                            })}
                                            <span style={{ fontSize: 11, color: "#888", marginLeft: 4 }}>
                                              — Click en un día para aplicarlo a todos los insumos
                                            </span>
                                          </div>
                                        </th>
                                      </tr>
                                    );
                                  })()}
                                </thead>
                              ) : null}

                              {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                                const insumos = this.formRef.current.getFieldValue('insumos');
                                const valueInsumo = insumos[arrayKey];
                                const mostrarFamilia = valueInsumo.familiaId !== familiaAnteriorId || arrayKey === 0;
                                familiaAnteriorId = valueInsumo.familiaId;

                                const fechaEntregaForm = this.formRef.current.getFieldValue('fechaEntrega');
                                // Datos de días para este insumo
                                const diasData = valueInsumo.cantidadPorDia || {};
                                const totalDias = DIAS_SEMANA.reduce((acc, d) => acc + (Number(diasData[d.key]) || 0), 0);
                                const tieneDias = separarDias && totalDias > 0;
                                const seleccionados = diasSeleccionados[arrayKey] || new Set();
                                const diasConCantidad = DIAS_SEMANA.filter(d => (Number(diasData[d.key]) || 0) > 0);
                                const todosSeleccionados = diasConCantidad.length > 0 && diasConCantidad.every(d => seleccionados.has(d.key));
                                const totalSeleccionado = DIAS_SEMANA.reduce((acc, d) => seleccionados.has(d.key) ? acc + (Number(diasData[d.key]) || 0) : acc, 0);

                                const colapsada = this.familiaColapsada('manual', valueInsumo.familiaId);

                                return (
                                  <React.Fragment key={arrayKey}>
                                    {/* El banner sale a su propio <tbody> para poder esconder el
                                        del renglón completo sin llevárselo — y eso cubre también
                                        los <tr> extra que pinta cuando `separarDias` está prendido. */}
                                    {mostrarFamilia && (
                                      <tbody>
                                        <tr
                                          style={{ backgroundColor: "#e6f7ff", cursor: 'pointer' }}
                                          onClick={() => this.alternarFamilia('manual', valueInsumo.familiaId)}
                                          title={colapsada ? 'Mostrar los insumos de esta familia' : 'Ocultar los insumos de esta familia'}
                                        >
                                          <td className="td-border" colSpan="7" style={{ textAlign: 'left', padding: '12px 16px', borderBottom: '1px solid #91d5ff' }}>
                                            <span style={{ color: '#0050b3', marginLeft: 60, marginRight: 8 }}>
                                              {colapsada ? <RightOutlined /> : <DownOutlined />}
                                            </span>
                                            <span style={{ fontWeight: '800', fontSize: 11, color: '#0050b3', textTransform: 'uppercase', letterSpacing: 1 }}>
                                              {valueInsumo.familiaNombre ? valueInsumo.familiaNombre : 'Sin Familia'}
                                            </span>
                                            <span style={{ fontSize: 11, color: '#0050b3', opacity: 0.75, marginLeft: 12 }}>
                                              {this.contarPartidasFamilia(insumos, valueInsumo.familiaId)} partidas
                                            </span>
                                          </td>
                                          <td className="th-border" style={{ borderBottom: '1px solid #91d5ff' }}>
                                            <Tooltip title='Mejor Precio Familia'>
                                              {/* stopPropagation: el botón no debe colapsar la familia */}
                                              <CalculatorOutlined onClick={(e) => { e.stopPropagation(); this.calcularMejorPrecioManualFamilia(valueInsumo.familiaId); }} style={{ marginLeft: '5px', fontSize: 15, color: '#0050b3' }} />
                                            </Tooltip>
                                          </td>
                                          <td className="td-border" style={{ textAlign: 'center', borderBottom: '1px solid #91d5ff' }} colSpan="3"></td>
                                          {this.state.verInventario && (
                                            <td className="td-border" style={{ borderBottom: '1px solid #91d5ff' }}></td>
                                          )}
                                          <td className="th-border" style={{ borderBottom: '1px solid #91d5ff' }} >
                                            <Tooltip title='Totales Familia'>
                                              <CalculatorOutlined onClick={(e) => { e.stopPropagation(); this.pedirTotalesManualFamilia(valueInsumo.familiaId); }} style={{ marginLeft: '5px', fontSize: 15, color: '#0050b3' }} />
                                            </Tooltip>
                                          </td>
                                          <td className="td-border" style={{ textAlign: 'center', borderBottom: '1px solid #91d5ff' }}></td>
                                        </tr>
                                      </tbody>
                                    )}
                                  <tbody
                                    id={`insumo-row-${arrayKey}`}
                                    style={{
                                      ...(colapsada ? { display: 'none' } : {}),
                                      ...(this.state.insumoResaltado === arrayKey
                                        ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
                                        : {}),
                                    }}
                                  >
                                    {/* Acotado a ESTA fila: antes era un shouldUpdate
                                        desnudo y cualquier cambio en cualquier celda
                                        re-creaba el JSX de todos los renglones.
                                        Depende de que los escritores por fila usen
                                        aplicarFila() para dar identidad nueva solo
                                        a la fila tocada. */}
                                    <FormItem
                                      noStyle
                                      shouldUpdate={(p, c) => p.insumos?.[arrayKey] !== c.insumos?.[arrayKey]}
                                    >
                                      {({ getFieldValue }) => {
                                        const insumos = getFieldValue("insumos") || [];
                                        const insumo = insumos[arrayKey];
                                        const conversion = insumo?.conversion ? insumo.conversion : 1;
                                        const maximoConversion = calcularMaximoConversion(insumo.cantidad, insumo.cantidadOrdenada, conversion);

                                        const origenesRequisicion = Array.isArray(insumo?.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
                                          ? insumo.requisicionesOrigen
                                          : (insumo.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo?.cantidad }] : []);
                                        const tagsRequisicion = origenesRequisicion
                                          .map(origen => this.state.requisicionesAdicionales.find(r => r._id === origen.requisicionId))
                                          .filter(Boolean)
                                          .map(ra => ({ id: ra._id, nombre: ra.numero, fechaSolicitud: ra.fechaSolicitud, importancia: ra.importancia }));

                                        return (
                                          <>
                                            <tr>
                                              <td className="td-border">
                                                <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>{arrayKey + 1}</div>
                                              </td>
                                              <td
                                                className="td-border"
                                                style={{ cursor: 'pointer' }}
                                                onDoubleClick={() => {
                                                  const insumoSeleccionado = this.state.todasInsumos?.find(
                                                    (ins) => ins._id.toString() === insumo?.insumoId?.toString()
                                                  );
                                                  const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
                                                  const proyectoId = this.formRef.current.getFieldValue('proyectoId');
                                                  this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', proyectoId);
                                                }}
                                              >
                                                <FormItem {...restField} name={[name, "insumoId"]} noStyle>
                                                  <SelectInsumosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde autoFocus dropdownMatchSelectWidth={600} width="100%" placeholder="Insumo" tiposInsumos="compra" ocultarCodigoYUnidad onChange={(value, insumo) => this.onChangeInsumo(value, arrayKey, insumo)} disabled />
                                                </FormItem>
                                              </td>
                                              <td className="td-border">
                                                {(() => {
                                                  const insumoMaestro = this.state.todasInsumos?.find(
                                                    (v) => v._id?.toString() === insumo?.insumoId?.toString()
                                                  );
                                                  const unidad = insumoMaestro?.unidad;
                                                  const unidadTexto = typeof unidad === "object" && unidad !== null
                                                    ? (unidad.nombre || unidad.descripcion || "-")
                                                    : (unidad || "-");
                                                  return (
                                                    <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                                      {unidadTexto}
                                                    </div>
                                                  );
                                                })()}
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "cantidad"]} number noStyle><InputNumberItem sinBorde placeholder="Cantidad" disabled /></FormItem>
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "cantidadOrdenada"]} noStyle><InputNumberItem sinBorde placeholder="Cantidad Ordenada" disabled /></FormItem>
                                              </td>
                                              <td className="td-border" style={{ textAlign: 'center' }}>
                                                {tagsRequisicion.length > 0 ? (
                                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                                                    {tagsRequisicion.map(t => (
                                                      <Tooltip key={t.id} title={"Fecha de solicitud: " + (t.fechaSolicitud ? moment(t.fechaSolicitud).format("DD/MM/YYYY") : "")}>
                                                        <Tag color={this.obtenerColorTagRequisicion(t.importancia)} onClick={() => this.verRequisicionModal(t.id)}>{"Req. " + t.nombre}</Tag>
                                                      </Tooltip>
                                                    ))}
                                                  </div>
                                                ) : null}
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "fechaEntrega"]} noStyle><DatePickerItem /></FormItem>
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "proveedorId"]} margin noStyle>
                                                  <TreeSelectItem sinBorde style={{ width: "100%" }} placeholder="Proveedor" treeDefaultExpandAll onChange={(value) => this.onChangeProveedor(value, arrayKey)} treeData={Array.isArray(this.state.objetoProveedoresPInsumos[arrayKey]) ? this.state.objetoProveedoresPInsumos[arrayKey] : []} />
                                                </FormItem>
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "insumoProveedorId"]} noStyle>
                                                  <SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Insumo Proveedor" onChange={(value) => this.onChangeInsumoP(value, arrayKey)}>{this.state.objetoInsumosPInsumos[arrayKey]}</SelectItem>
                                                </FormItem>
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "costo"]} numberCero type="number" noStyle><InputNumberItem sinBorde disabled dineroDisabled placeholder="Costo" /></FormItem>
                                              </td>
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "conversion"]} numberCero type="number" noStyle><InputNumberItem sinBorde disabled placeholder="Conversion" /></FormItem>
                                                <AyudaConversion insumo={{ _id: insumo.insumoProveedorId, conversion: insumo.conversion }} cantidad={insumo.pedir} />
                                              </td>
                                              {this.state.verInventario && (
                                                <td className="td-border" style={{ textAlign: 'center' }}>
                                                  {this.state.inventarioData[arrayKey] !== undefined
                                                    ? this.state.inventarioData[arrayKey]
                                                    : '-'}
                                                </td>
                                              )}
                                              <td className="td-border">
                                                <FormItem {...restField} name={[name, "pedir"]} max={maximoConversion} numberCero type="number" noStyle>
                                                  <InputNumberItem sinBorde placeholder={"Max: " + (maximoConversion)} />
                                                </FormItem>
                                              </td>
                                              <td className="td-border-sin-right">
                                                <Row className="acciones-container">
                                                  <Col span={24}>
                                                    <Space
                                                      style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                      size={0}
                                                      className="acciones-container"
                                                    >
                                                      <Tooltip title="Asignar Proveedor" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                        <ButtonItem type="link" onClick={() => this.asignarProveedor(arrayKey)} icon={<UserOutlined />}>
                                                        </ButtonItem>
                                                      </Tooltip>
                                                      <FormItem
                                                        noStyle
                                                        shouldUpdate={(p, c) =>
                                                          p.insumos?.[arrayKey]?.insumoId !== c.insumos?.[arrayKey]?.insumoId ||
                                                          p.insumos?.[arrayKey]?.observaciones !== c.insumos?.[arrayKey]?.observaciones
                                                        }
                                                      >
                                                        {({ getFieldValue }) => {
                                                          let av = getFieldValue("insumos") || [];
                                                          let buttons = [];
                                                          if (av[arrayKey]?.insumoId && this.state.todasInsumos) {
                                                            buttons.push(
                                                              <Tooltip key="obs-tooltip" title="Agregar Observaciones" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                                <ButtonItem
                                                                  key="obs"
                                                                  type="primary"
                                                                  size="small"
                                                                  cyan2
                                                                  icon={<CommentOutlined />}
                                                                  verde={av[arrayKey]?.observaciones}
                                                                  onClick={() => this.abrirObservaciones(arrayKey, av[arrayKey]?.observaciones, av[arrayKey]?.insumoId, av[arrayKey].observacionesXml)}
                                                                />
                                                              </Tooltip>
                                                            );
                                                          }
                                                          return buttons;
                                                        }}
                                                      </FormItem>
                                                    </Space>
                                                  </Col>
                                                </Row>
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      }}
                                    </FormItem>

                                    {/* ── Fila de días seleccionables (solo si tieneDias) ── */}
                                    {tieneDias && (
                                      <tr>
                                        <td
                                          colSpan={13 + (this.state.verInventario ? 1 : 0)}
                                          className="td-border"
                                          style={{ padding: "6px 10px", backgroundColor: "#f0f9ff" }}
                                        >
                                          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                            {/* Botón "Todos" */}
                                            <Tooltip title={todosSeleccionados ? "Deseleccionar todos" : "Seleccionar todos"}>
                                              <div
                                                onClick={() => this.toggleTodosDias(arrayKey)}
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "center",
                                                  minWidth: 48,
                                                  padding: "3px 8px",
                                                  background: todosSeleccionados ? "#1890ff" : "#e6f7ff",
                                                  border: `2px solid ${todosSeleccionados ? "#096dd9" : "#91d5ff"}`,
                                                  borderRadius: 6,
                                                  cursor: "pointer",
                                                  userSelect: "none",
                                                  transition: "all 0.15s",
                                                }}
                                              >
                                                <span style={{ fontSize: 10, fontWeight: 700, color: todosSeleccionados ? "#fff" : "#1890ff", lineHeight: 1, marginBottom: 1 }}>
                                                  {todosSeleccionados ? "✓ Todos" : "Todos"}
                                                </span>
                                                <span style={{ fontSize: 12, fontWeight: 700, color: todosSeleccionados ? "#fff" : "#1890ff" }}>
                                                  {totalDias}
                                                </span>
                                              </div>
                                            </Tooltip>

                                            <span style={{ fontSize: 11, color: "#888", margin: "0 2px" }}>|</span>

                                            {/* Un chip por día */}
                                            {DIAS_SEMANA.map((dia, idxDia) => {
                                              const cantDia = Number(diasData[dia.key]) || 0;
                                              const estaSeleccionado = seleccionados.has(dia.key);
                                              const sinCantidad = cantDia === 0;
                                              const fechaDia = fechaEntregaForm ? moment(fechaEntregaForm).add(idxDia, "days") : null;

                                              return (
                                                <Tooltip
                                                  key={dia.key}
                                                  title={
                                                    sinCantidad
                                                      ? `${dia.label}: sin cantidad`
                                                      : estaSeleccionado
                                                        ? `Deseleccionar ${dia.label} (${cantDia})`
                                                        : `Seleccionar ${dia.label} (${cantDia})`
                                                  }
                                                >
                                                  <div
                                                    onClick={() => !sinCantidad && this.toggleDia(arrayKey, dia.key, cantDia)}
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "center",
                                                      minWidth: 52,
                                                      padding: "3px 6px",
                                                      background: sinCantidad
                                                        ? "#f5f5f5"
                                                        : estaSeleccionado
                                                          ? "#1890ff"
                                                          : "#e6f7ff",
                                                      border: `2px solid ${sinCantidad ? "#d9d9d9" : estaSeleccionado ? "#096dd9" : "#91d5ff"}`,
                                                      borderRadius: 6,
                                                      cursor: sinCantidad ? "default" : "pointer",
                                                      opacity: sinCantidad ? 0.45 : 1,
                                                      userSelect: "none",
                                                      transition: "all 0.15s",
                                                      position: "relative",
                                                    }}
                                                  >
                                                    {estaSeleccionado && (
                                                      <CheckCircleFilled style={{ position: "absolute", top: -5, right: -5, fontSize: 12, color: "#52c41a", background: "#fff", borderRadius: "50%" }} />
                                                    )}
                                                    <span style={{
                                                      fontSize: 10, fontWeight: 700,
                                                      color: sinCantidad ? "#bfbfbf" : estaSeleccionado ? "#fff" : "#1890ff",
                                                      lineHeight: 1, marginBottom: 1
                                                    }}>
                                                      {dia.label}
                                                      {fechaDia && (
                                                        <span style={{ fontWeight: 400, marginLeft: 3, opacity: 0.85 }}>
                                                          {fechaDia.format("DD")}
                                                        </span>
                                                      )}
                                                    </span>
                                                    <span style={{
                                                      fontSize: 13, fontWeight: 700,
                                                      color: sinCantidad ? "#bfbfbf" : estaSeleccionado ? "#fff" : "#1890ff"
                                                    }}>
                                                      {cantDia}
                                                    </span>
                                                  </div>
                                                </Tooltip>
                                              );
                                            })}

                                            {/* Total seleccionado */}
                                            {totalSeleccionado > 0 && (
                                              <>
                                                <span style={{ fontSize: 11, color: "#888", margin: "0 2px" }}>→</span>
                                                <div style={{
                                                  display: "flex", flexDirection: "column", alignItems: "center",
                                                  padding: "3px 10px", background: "#fff7e6",
                                                  border: "2px solid #ffd591", borderRadius: 6, minWidth: 60,
                                                }}>
                                                  <span style={{ fontSize: 10, color: "#fa8c16", lineHeight: 1, marginBottom: 1, fontWeight: 600 }}>Selec.</span>
                                                  <span style={{ fontSize: 14, fontWeight: 700, color: "#fa8c16" }}>{totalSeleccionado}</span>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    )}

                                    {/* ── Fila de observaciones ── */}
                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos?.[arrayKey]?.observaciones !== curr.insumos?.[arrayKey]?.observaciones}>
                                      {({ getFieldValue }) => {
                                        let av = getFieldValue("insumos");
                                        if (av[arrayKey]?.observaciones) {
                                          return (
                                            <tr>
                                              <td colSpan={12 + (this.state.verInventario ? 1 : 0)} className="td-border-sin-right">
                                                <div style={{ display: "flex", justifyContent: "left", alignItems: "left", backgroundColor: "white" }}>
                                                  <div style={{ width: "90%", textAlign: "left", paddingLeft: 20 }}>
                                                    {String(av[arrayKey].observaciones).split(/\r?\n/).map((line, i) => (<span key={i}>{line}<br /></span>))}
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      }}
                                    </FormItem>
                                  </tbody>
                                  </React.Fragment>
                                );
                              })}
                            </table>
                          </div>
                        )}
                      </FormInitial.List>
                    </Spin>
                  </TabPane>

                  {/* ─────────────── TAB PEDIDO INTELIGENTE ─────────────── */}
                  <TabPane tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Pedido Inteligente</span>} key='2' forceRender>
                    <Spin spinning={this.state.loadingPedidoInteligente}>
                      <FormInitial.List name="insumosInteligente">
                        {(fields) => (
                          <div className="tabla-insumos-venta requisiciones-celdas-amplias" style={{ overflowX: 'auto' }}>
                          <table className="table table-12px" style={{ minWidth: isMobile ? "900px" : "100%", backgroundColor: "white" }}>
                            {fields.length > 0 ? (
                              <thead><tr>
                                <th className="th-border" style={{ width: "3%" }}>#</th>
                                <th className="th-border" style={{ width: "16%" }}>Insumo</th>
                                <th className="th-border" style={{ width: "5%" }}>Unidad</th>
                                <th className="th-border" style={{ width: "10%" }}>Cantidad</th>
                                <th className="th-border" style={{ width: "15%" }}>Proveedor</th>
                                <th className="th-border" style={{ width: "18%" }}>Insumo Proveedor</th>
                                <th className="th-border" style={{ width: "10%" }}>Conversion</th>
                                <th className="th-border" style={{ width: "10%" }}>Cantidad Pedir</th>
                                <th className="th-border" style={{ width: "13%" }}>Cantidad A Pedir <Tooltip title='Totales'><CalculatorOutlined onClick={() => this.pedirTotalesInteligente()} style={{ marginLeft: '5px', color: '#00b5e2' }} /></Tooltip></th>
                              </tr></thead>
                            ) : null}
                            {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                              const insumos = this.formRef.current.getFieldValue('insumosInteligente');
                              const valueInsumo = insumos[arrayKey];
                              const mostrarFamilia = valueInsumo.familiaId !== familiaAnteriorInteligenteId || arrayKey === 0;
                              familiaAnteriorInteligenteId = valueInsumo.familiaId;
                              const colapsada = this.familiaColapsada('inteligente', valueInsumo.familiaId);
                              return (
                                <React.Fragment key={arrayKey}>
                                  {mostrarFamilia && (
                                    <tbody>
                                      <tr
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.alternarFamilia('inteligente', valueInsumo.familiaId)}
                                        title={colapsada ? 'Mostrar los insumos de esta familia' : 'Ocultar los insumos de esta familia'}
                                      >
                                        <td className="td-border" colSpan="8" style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 20, paddingLeft: 10 }}>
                                          <h1 style={{ paddingTop: 0, paddingBottom: 0 }}>
                                            <span style={{ marginRight: 8, fontSize: 14, color: '#00b5e2' }}>
                                              {colapsada ? <RightOutlined /> : <DownOutlined />}
                                            </span>
                                            {valueInsumo.familiaNombre ? valueInsumo.familiaNombre : 'Sin Familia'}
                                            <span style={{ fontSize: 12, color: '#868585', fontWeight: 400, marginLeft: 12 }}>
                                              {this.contarPartidasFamilia(insumos, valueInsumo.familiaId)} partidas
                                            </span>
                                          </h1>
                                        </td>
                                        <td className="th-border">
                                          <Tooltip title='Totales Familia'>
                                            {/* stopPropagation: el botón no debe colapsar la familia */}
                                            <CalculatorOutlined onClick={(e) => { e.stopPropagation(); this.pedirTotalesInteligenteFamilia(valueInsumo.familiaId); }} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                          </Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  )}
                                <tbody
                                  id={`insumo-row-${arrayKey}`}
                                  style={{
                                    ...(colapsada ? { display: 'none' } : {}),
                                    ...(this.state.insumoResaltado === arrayKey
                                      ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
                                      : {}),
                                  }}
                                >
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(p, c) =>
                                      p.insumosInteligente?.[arrayKey] !== c.insumosInteligente?.[arrayKey]
                                    }
                                  >
                                    {({ getFieldValue }) => {
                                      const insumos = getFieldValue("insumosInteligente") || [];
                                      const insumo = insumos[arrayKey];
                                      const maximoConversion = insumo.cantidad;
                                      return (
                                        <>
                                          <tr>
                                            <td className="td-border"><div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>{arrayKey + 1}</div></td>
                                            <td
                                              className="td-border"
                                              style={{ cursor: 'pointer' }}
                                              onDoubleClick={() => {
                                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                                  (ins) => ins._id.toString() === insumo?.insumoId?.toString()
                                                );
                                                const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
                                                const proyectoId = this.formRef.current.getFieldValue('proyectoId');
                                                this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', proyectoId);
                                              }}
                                            >
                                              <FormItem {...restField} name={[name, "insumoId"]} noStyle><SelectInsumosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde autoFocus dropdownMatchSelectWidth={600} width="100%" placeholder="Insumo" tiposInsumos="compra" ocultarCodigoYUnidad disabled /></FormItem>
                                            </td>
                                            <td className="td-border">
                                              {(() => {
                                                const insumoMaestro = this.state.todasInsumos?.find(
                                                  (v) => v._id?.toString() === insumo?.insumoId?.toString()
                                                );
                                                const unidad = insumoMaestro?.unidad;
                                                const unidadTexto = typeof unidad === "object" && unidad !== null
                                                  ? (unidad.nombre || unidad.descripcion || "-")
                                                  : (unidad || "-");
                                                return (
                                                  <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                                    {unidadTexto}
                                                  </div>
                                                );
                                              })()}
                                            </td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "cantidadInsumo"]} number noStyle><InputNumberItem sinBorde placeholder="Cantidad" disabled /></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "proveedorId"]} margin noStyle><SelectItem sinBorde disabled style={{ width: "100%" }} placeholder="Proveedor">{this.state.objetoProveedores}</SelectItem></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "insumoProveedorId"]} noStyle><SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Insumo Proveedor" disabled>{this.state.objetoInsumosPInsumos[arrayKey]}</SelectItem></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "conversion"]} numberCero type="number" noStyle><InputNumberItem sinBorde disabled placeholder="Conversion" /></FormItem><AyudaConversion insumo={{ _id: insumo.insumoProveedorId, conversion: insumo.conversion }} cantidad={insumo.pedir} /></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "cantidad"]} required number noStyle><InputNumberItem sinBorde placeholder="Cantidad Pedir" disabled /></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "pedir"]} max={maximoConversion} numberCero type="number" noStyle><InputNumberItem sinBorde placeholder={"Max: " + (maximoConversion)} /></FormItem></td>
                                          </tr>
                                        </>
                                      );
                                    }}
                                  </FormItem>
                                </tbody>
                                </React.Fragment>
                              );
                            })}
                          </table>
                          </div>
                        )}
                      </FormInitial.List>
                    </Spin>
                  </TabPane>

                  {/* ─────────────── TAB PROVEEDOR DEFAULT ─────────────── */}
                  <TabPane tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Proveedor Default</span>} key='3' forceRender>
                    <Spin spinning={this.state.loadingPedidoProveedorDefault}>
                      <FormInitial.List name="insumosProveedorDefault">
                        {(fields) => (
                          <div className="tabla-insumos-venta requisiciones-celdas-amplias" style={{ overflowX: 'auto' }}>
                          <table className="table table-12px" style={{ minWidth: isMobile ? "900px" : "100%", backgroundColor: "white" }}>
                            {fields.length > 0 ? (
                              <thead><tr>
                                <th className="th-border" style={{ width: "3%" }}>#</th>
                                <th className="th-border" style={{ width: "16%" }}>Insumo</th>
                                <th className="th-border" style={{ width: "5%" }}>Unidad</th>
                                <th className="th-border" style={{ width: "10%" }}>Cantidad</th>
                                <th className="th-border" style={{ width: "15%" }}>Proveedor</th>
                                <th className="th-border" style={{ width: "18%" }}>Insumo Proveedor</th>
                                <th className="th-border" style={{ width: "10%" }}>Conversion</th>
                                <th className="th-border" style={{ width: "10%" }}>Cantidad Pedir</th>
                                <th className="th-border" style={{ width: "13%" }}>Cantidad A Pedir <Tooltip title='Totales'><CalculatorOutlined onClick={() => this.pedirTotalesDefault()} style={{ marginLeft: '5px', color: '#00b5e2' }} /></Tooltip></th>
                              </tr></thead>
                            ) : null}
                            {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                              const insumos = this.formRef.current.getFieldValue('insumosProveedorDefault');
                              const valueInsumo = insumos[arrayKey];
                              const mostrarFamilia = valueInsumo.familiaId !== familiaAnteriorDefaultId || arrayKey === 0;
                              familiaAnteriorDefaultId = valueInsumo.familiaId;
                              const colapsada = this.familiaColapsada('default', valueInsumo.familiaId);
                              return (
                                <React.Fragment key={arrayKey}>
                                  {mostrarFamilia && (
                                    <tbody>
                                      <tr
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.alternarFamilia('default', valueInsumo.familiaId)}
                                        title={colapsada ? 'Mostrar los insumos de esta familia' : 'Ocultar los insumos de esta familia'}
                                      >
                                        <td className="td-border" colSpan="8" style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 20, paddingLeft: 10 }}>
                                          <h1 style={{ paddingTop: 0, paddingBottom: 0 }}>
                                            <span style={{ marginRight: 8, fontSize: 14, color: '#00b5e2' }}>
                                              {colapsada ? <RightOutlined /> : <DownOutlined />}
                                            </span>
                                            {valueInsumo.familiaNombre ? valueInsumo.familiaNombre : 'Sin Familia'}
                                            <span style={{ fontSize: 12, color: '#868585', fontWeight: 400, marginLeft: 12 }}>
                                              {this.contarPartidasFamilia(insumos, valueInsumo.familiaId)} partidas
                                            </span>
                                          </h1>
                                        </td>
                                        <td className="th-border">
                                          <Tooltip title='Totales Familia'>
                                            {/* stopPropagation: el botón no debe colapsar la familia */}
                                            <CalculatorOutlined onClick={(e) => { e.stopPropagation(); this.pedirTotalesDefaultFamilia(valueInsumo.familiaId); }} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                          </Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  )}
                                <tbody
                                  id={`insumo-row-${arrayKey}`}
                                  style={{
                                    ...(colapsada ? { display: 'none' } : {}),
                                    ...(this.state.insumoResaltado === arrayKey
                                      ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
                                      : {}),
                                  }}
                                >
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(p, c) =>
                                      p.insumosProveedorDefault?.[arrayKey] !== c.insumosProveedorDefault?.[arrayKey]
                                    }
                                  >
                                    {({ getFieldValue }) => {
                                      const insumos = getFieldValue("insumosProveedorDefault") || [];
                                      const insumo = insumos[arrayKey];
                                      const maximoConversion = insumo.cantidad;
                                      return (
                                        <>
                                          <tr>
                                            <td className="td-border"><div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>{arrayKey + 1}</div></td>
                                            <td
                                              className="td-border"
                                              style={{ cursor: 'pointer' }}
                                              onDoubleClick={() => {
                                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                                  (ins) => ins._id.toString() === insumo?.insumoId?.toString()
                                                );
                                                const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
                                                const proyectoId = this.formRef.current.getFieldValue('proyectoId');
                                                this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', proyectoId);
                                              }}
                                            >
                                              <FormItem {...restField} name={[name, "insumoId"]} noStyle><SelectInsumosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde autoFocus dropdownMatchSelectWidth={600} width="100%" placeholder="Insumo" tiposInsumos="compra" ocultarCodigoYUnidad disabled /></FormItem>
                                            </td>
                                            <td className="td-border">
                                              {(() => {
                                                const insumoMaestro = this.state.todasInsumos?.find(
                                                  (v) => v._id?.toString() === insumo?.insumoId?.toString()
                                                );
                                                const unidad = insumoMaestro?.unidad;
                                                const unidadTexto = typeof unidad === "object" && unidad !== null
                                                  ? (unidad.nombre || unidad.descripcion || "-")
                                                  : (unidad || "-");
                                                return (
                                                  <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                                    {unidadTexto}
                                                  </div>
                                                );
                                              })()}
                                            </td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "cantidadInsumo"]} number noStyle><InputNumberItem sinBorde placeholder="Cantidad" disabled /></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "proveedorId"]} margin noStyle><SelectItem sinBorde disabled style={{ width: "100%" }} placeholder="Proveedor">{this.state.objetoProveedores}</SelectItem></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "insumoProveedorId"]} noStyle><SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Insumo Proveedor" disabled>{this.state.objetoInsumosPInsumos[arrayKey]}</SelectItem></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "conversion"]} numberCero type="number" noStyle><InputNumberItem sinBorde disabled placeholder="Conversion" /></FormItem><AyudaConversion insumo={{ _id: insumo.insumoProveedorId, conversion: insumo.conversion }} cantidad={insumo.pedir} /></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "cantidad"]} required number noStyle><InputNumberItem sinBorde placeholder="Cantidad Pedir" disabled /></FormItem></td>
                                            <td className="td-border"><FormItem {...restField} name={[name, "pedir"]} max={maximoConversion} numberCero type="number" noStyle><InputNumberItem sinBorde placeholder={"Max: " + (maximoConversion)} /></FormItem></td>
                                          </tr>
                                        </>
                                      );
                                    }}
                                  </FormItem>
                                </tbody>
                                </React.Fragment>
                              );
                            })}
                          </table>
                          </div>
                        )}
                      </FormInitial.List>
                    </Spin>
                  </TabPane>
                </Tabs>

                {this.state.mostrarCostosRequisicion && (
                  <FormItem
                    noStyle
                    shouldUpdate={(p, c) =>
                      p.insumos !== c.insumos ||
                      p.insumosInteligente !== c.insumosInteligente ||
                      p.insumosProveedorDefault !== c.insumosProveedorDefault
                    }
                  >
                    {({ getFieldValue }) => {
                      const lista = { '1': 'insumos', '2': 'insumosInteligente', '3': 'insumosProveedorDefault' }[this.state.activeTab];
                      const { subtotal, impuestos, total } = this.calcularTotalesPedido(getFieldValue(lista));
                      return (
                        <GeneralFormLayout
                          isMobile={isMobile}
                          observacionesConfig={{
                            totales: (
                              <table className="table" style={{ borderCollapse: "collapse", width: "100%", margin: "0" }}>
                                <tbody>
                                  <tr>
                                    <th className="th-totales" style={{ width: "50%" }}>Subtotal: </th>
                                    <td className="td-totales-right">{dineroDisabledMask(subtotal)}</td>
                                  </tr>
                                  <tr>
                                    <th className="th-totales" style={{ width: "50%" }}>Impuestos: </th>
                                    <td className="td-totales-right">{dineroDisabledMask(impuestos)}</td>
                                  </tr>
                                  <tr>
                                    <th className="th-totales" style={{ width: "50%" }}>Total: </th>
                                    <td className="td-totales-right">{dineroDisabledMask(total)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            ),
                          }}
                        />
                      );
                    }}
                  </FormItem>
                )}

                <div className="general-form-action-buttons-wrapper">
                  <div className="general-form-action-buttons">
                    {this.state.activeTab === '1' && (
                      <ButtonItem type="primary" blanco tooltip="Agregar los insumos a una orden de compra existente" onClick={() => this.agregarAOrdenDeCompraExistente(1)}>Agregar existente</ButtonItem>
                    )}
                    <ButtonItem type="primary" cyanB onClick={() => this.confimacionGenerar(Number(this.state.activeTab))}>Generar</ButtonItem>
                  </div>
                </div>
                </div>
              </div>
            </Form>
          </Spin>
        </div>

        <AsignarProveedor insumoId={this.state.modalAsignarProveedorInsumoId} visible={this.state.modalAsignarProveedor} cerrarAsignarProveedor={this.cerrarAsignarProveedor.bind(this)} empresaId={this.props.empresaId} headersToken={this.props.headersToken} />
        <ModalAgregarInsumosAExistente requisicionId={this.props.requisicionId} proveedorId={this.state.modalAgregarAOrdenDeCompraExistenteProveedorId} insumos={this.state.modalAgregarAOrdenDeCompraExistenteInsumos} visible={this.state.modalAgregarAOrdenDeCompraExistente} onCancel={this.onCancelModalAgregarInsumosAExistente.bind(this)} onConfirm={this.onConfirmModalAgregarInsumosAExistente.bind(this)} empresaId={this.props.empresaId} headersToken={this.props.headersToken} />
        <ModalVerRequisicion visible={this.state.modalVerRequisicion} requisicionId={this.state.modalVerRequisicionId} onClose={this.cerrarModalVerRequisicion.bind(this)} cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)} />
        <ElegirObservaciones visible={this.state.modalObservaciones} cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)} observaciones={this.state.modalObservacionesObservaciones} observacionesPasadas={this.state.modalObservacionesObservacionesPasadas} observacionesXml={this.state.modalObservacionesObservacionesXml} noXml />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
        <ModalItem
          title="Consultar precios online"
          visible={this.state.modalConfirmarConsultarPrecios}
          onCancel={() => this.setState({ modalConfirmarConsultarPrecios: false })}
          onOk={this.iniciarConsultaPrecios}
          spinning={false}
          footer
        >
          <div style={{ textAlign: "center", padding: "10px 20px" }}>
            <ClockCircleOutlined style={{ fontSize: 36, color: "#faad14", marginBottom: 12 }} />
            <h2 style={{ marginBottom: 8 }}>Esta consulta puede tardar varios minutos</h2>
            <p style={{ color: "#555", marginBottom: 6 }}>
              Se buscarán los precios y disponibilidad en los portales de cada proveedor para todos los insumos de la requisición.
            </p>
            <p style={{ color: "#888", fontSize: 12 }}>
              No cierres esta pantalla mientras se realiza la consulta. Al terminar verás una tabla comparativa.
            </p>
          </div>
        </ModalItem>

        <ModalItem
          title="Comparativa de precios online"
          visible={this.state.modalConsultarPrecios}
          onCancel={this.cerrarConsultaPrecios}
          spinning={false}
          width={Math.min(1200, window.innerWidth - 40)}
          footer
          onOk={this.cerrarConsultaPrecios}
        >
          {this.state.loadingConsultarPrecios ? (
            <div style={{ textAlign: "center", padding: "30px 20px" }}>
              <LoadingOutlined style={{ fontSize: 36, color: "#00BFD6", marginBottom: 12 }} />
              <h2 style={{ marginBottom: 4 }}>Consultando precios en los proveedores...</h2>
              <p style={{ color: "#888", marginBottom: 20 }}>
                Esto puede tardar varios minutos, por favor espera.
              </p>
              {this.state.totalProgreso ? (
                <div style={{ maxWidth: 420, margin: "0 auto 16px" }}>
                  <div
                    style={{
                      height: 8,
                      background: "#f0f0f0",
                      borderRadius: 4,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${Math.min(
                          100,
                          ((this.state.completadosProgreso || 0) / this.state.totalProgreso) * 100
                        )}%`,
                        background: "#00BFD6",
                        transition: "width 0.3s ease",
                      }}
                    />
                  </div>
                  <div style={{ fontSize: 12, color: "#555", marginTop: 6 }}>
                    {this.state.completadosProgreso || 0} / {this.state.totalProgreso}
                  </div>
                </div>
              ) : null}
              {this.state.progresoConsulta && this.state.progresoConsulta.length > 0 && (
                <div
                  style={{
                    maxWidth: 360,
                    margin: "0 auto",
                    textAlign: "left",
                    background: "#fafafa",
                    border: "1px solid #f0f0f0",
                    borderRadius: 6,
                    padding: "8px 12px",
                  }}
                >
                  {this.state.progresoConsulta.map((p) => {
                    let icono;
                    let texto;
                    let color = "#555";
                    let progressStatus = "active";
                    let strokeColor = "#00BFD6";
                    if (p.estado === "ok") {
                      icono = (
                        <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16 }} />
                      );
                      texto = `${p.nombre} listo`;
                      color = "#262626";
                      progressStatus = "success";
                      strokeColor = "#52c41a";
                    } else if (p.estado === "error") {
                      icono = (
                        <CloseCircleOutlined style={{ color: "#ff4d4f", fontSize: 16 }} />
                      );
                      texto = `${p.nombre} falló`;
                      color = "#ff4d4f";
                      progressStatus = "exception";
                      strokeColor = "#ff4d4f";
                    } else if (p.estado === "scrapeando") {
                      icono = (
                        <LoadingOutlined style={{ color: "#00BFD6", fontSize: 16 }} />
                      );
                      texto = p.terminoActual
                        ? `${p.nombre} — ${p.terminoActual}`
                        : `Consultando ${p.nombre}...`;
                    } else {
                      icono = (
                        <LoadingOutlined style={{ color: "#00BFD6", fontSize: 16 }} />
                      );
                      texto = `Consultando ${p.nombre}...`;
                    }
                    const porcentaje =
                      typeof p.porcentaje === "number"
                        ? Math.max(0, Math.min(100, p.porcentaje))
                        : p.estado === "ok"
                          ? 100
                          : 0;
                    return (
                      <div key={p.tipo} style={{ padding: "4px 0" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 8,
                            fontSize: 13,
                            color,
                          }}
                        >
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                            {icono}
                            <span>{texto}</span>
                          </span>
                          {typeof p.terminosCompletados === "number" &&
                            typeof p.terminosTotal === "number" && (
                              <span style={{ fontSize: 11, color: "#8c8c8c" }}>
                                {p.terminosCompletados}/{p.terminosTotal}
                              </span>
                            )}
                        </div>
                        <Progress
                          percent={porcentaje}
                          status={progressStatus}
                          strokeColor={strokeColor}
                          showInfo={false}
                          size="small"
                          style={{ marginBottom: 0 }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : this.state.consultarPreciosData ? (
            (() => {
              const { proveedores, insumos } = this.state.consultarPreciosData;
              if (!proveedores?.length || !insumos?.length) {
                return <p style={{ textAlign: "center", padding: 20 }}>No se obtuvieron resultados.</p>;
              }
              const tipoColor = {
                levic: "#1677ff",
                nadro: "#722ed1",
                rosario: "#fa8c16",
              };
              const insumosForm = this.formRef.current?.getFieldValue("insumos") || [];
              const requeridoPorInsumo = {};
              const cantidadTotalPorInsumo = {};
              for (const fi of insumosForm) {
                if (!fi?.insumoId) continue;
                const cantRaw =
                  fi.cantidad ?? fi.cantidadInsumo ?? fi.cantidadOriginal ?? null;
                const cantNum = Number(cantRaw);
                if (!cantNum || isNaN(cantNum)) continue;
                const ordenada = Number(fi.cantidadOrdenada) || 0;
                const restante = Math.max(0, cantNum - ordenada);
                requeridoPorInsumo[fi.insumoId.toString()] = restante;
                cantidadTotalPorInsumo[fi.insumoId.toString()] = cantNum;
              }
              const tieneAlgunResultado = (ins) =>
                (ins.proveedores || []).some(
                  (p) =>
                    p &&
                    !p.error &&
                    (typeof p.precio === "number" ||
                      typeof p.cantidadDisponible === "number" ||
                      p.disponible === true ||
                      (Array.isArray(p.relaciones) &&
                        p.relaciones.some(
                          (r) =>
                            r &&
                            !r.error &&
                            (typeof r.precio === "number" ||
                              typeof r.cantidadDisponible === "number" ||
                              r.disponible === true)
                        )))
                );
              const insumosFiltrados = this.state.ocultarInsumosSinResultados
                ? insumos.filter(tieneAlgunResultado)
                : insumos;
              const ocultados = insumos.length - insumosFiltrados.length;
              return (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 12,
                      flexWrap: "wrap",
                      marginBottom: 8,
                    }}
                  >
                    <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
                      Haz click en una celda para asignar ese proveedor al insumo en la orden de compra.
                    </p>
                    <label
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 12,
                        cursor: "pointer",
                      }}
                    >
                      <SwitchItem
                        size="small"
                        checked={this.state.ocultarInsumosSinResultados}
                        onChange={(checked) =>
                          this.setState({ ocultarInsumosSinResultados: checked })
                        }
                      />
                      <span>
                        Ocultar insumos sin resultados
                        {ocultados > 0 && this.state.ocultarInsumosSinResultados
                          ? ` (${ocultados} ocultos)`
                          : ""}
                      </span>
                    </label>
                  </div>
                  <div
                    style={{
                      overflowX: "auto",
                      maxHeight: "65vh",
                      overflowY: "auto",
                      border: "1px solid #e8e8e8",
                      borderRadius: 6,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                    }}
                  >
                    <table
                      className="table"
                      style={{
                        width: "100%",
                        minWidth: 600,
                        borderCollapse: "separate",
                        borderSpacing: 0,
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              minWidth: 200,
                              position: "sticky",
                              top: 0,
                              left: 0,
                              background: "#f0f5ff",
                              zIndex: 3,
                              padding: "10px 12px",
                              textAlign: "left",
                              fontSize: 12,
                              fontWeight: 700,
                              color: "#1d39c4",
                              borderBottom: "2px solid #adc6ff",
                              borderRight: "1px solid #e8e8e8",
                            }}
                          >
                            Insumo
                          </th>
                          {proveedores.map((prov) => {
                            const color = tipoColor[prov.tipo] || "#8c8c8c";
                            const estadoOk = prov.estado === "ok";
                            const etiqueta = prov.tipo
                              ? prov.tipo.charAt(0).toUpperCase() + prov.tipo.slice(1)
                              : prov.nombre || "Proveedor";
                            return (
                              <th
                                key={prov.proveedorId}
                                title={prov.nombre}
                                style={{
                                  minWidth: 150,
                                  textAlign: "center",
                                  padding: "12px 10px",
                                  background: "#fafafa",
                                  borderBottom: `3px solid ${color}`,
                                  borderRight: "1px solid #e8e8e8",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                  verticalAlign: "middle",
                                }}
                              >
                                <div
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 800,
                                      fontSize: 20,
                                      color: color,
                                      lineHeight: 1,
                                      letterSpacing: 0.3,
                                    }}
                                  >
                                    {etiqueta}
                                  </span>
                                  <span
                                    title={estadoOk ? "Disponible" : "Error en la consulta"}
                                    style={{
                                      width: 10,
                                      height: 10,
                                      borderRadius: "50%",
                                      background: estadoOk ? "#52c41a" : "#ff4d4f",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {insumosFiltrados.map((ins, rowIdx) => {
                          const insumoMaestro = this.state.todasInsumos.find((v) => v._id.toString() === ins.insumoId?.toString());
                          const descripcion = insumoMaestro?.descripcion || ins.descripcion || "Insumo";
                          const codigo = insumoMaestro?.codigo || ins.codigo;
                          const seleccionadoProvId = this.state.proveedoresAsignadosScrap[ins.insumoId?.toString()];
                          const rowBg = rowIdx % 2 === 0 ? "#ffffff" : "#fafafa";
                          const cantidadRequeridaBack = Number(ins.cantidadSolicitada);
                          const requeridoFallback = requeridoPorInsumo[ins.insumoId?.toString()];
                          const requerido =
                            !isNaN(cantidadRequeridaBack) && cantidadRequeridaBack > 0
                              ? cantidadRequeridaBack
                              : requeridoFallback;
                          const cantidadTotal = cantidadTotalPorInsumo[ins.insumoId?.toString()];
                          const yaOrdenado =
                            typeof cantidadTotal === "number" && typeof requerido === "number"
                              ? Math.max(0, cantidadTotal - requerido)
                              : 0;
                          const preciosValidos = (ins.proveedores || [])
                            .filter((p) => p && !p.error && typeof p.precio === "number" && !isNaN(p.precio))
                            .map((p) => ({ id: p.proveedorId?.toString(), precio: p.precio }));
                          const mejorPrecio = preciosValidos.length
                            ? Math.min(...preciosValidos.map((p) => p.precio))
                            : null;
                          return (
                            <tr key={ins.insumoId}>
                              <td
                                style={{
                                  position: "sticky",
                                  left: 0,
                                  background: rowBg,
                                  zIndex: 1,
                                  fontWeight: 600,
                                  fontSize: 12,
                                  padding: "8px 12px",
                                  borderBottom: "1px solid #f0f0f0",
                                  borderRight: "1px solid #e8e8e8",
                                  color: "#262626",
                                }}
                              >
                                {codigo && (
                                  <div style={{ fontSize: 10, color: "#8c8c8c", marginBottom: 2 }}>
                                    {codigo}
                                  </div>
                                )}
                                <div>{descripcion}</div>
                                {typeof requerido === "number" && requerido > 0 && (
                                  <div
                                    style={{
                                      marginTop: 4,
                                      background: "#fffbe6",
                                      border: "1px solid #ffe58f",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 6,
                                      whiteSpace: "nowrap",
                                      fontSize: 12,
                                    }}
                                    title={
                                      yaOrdenado > 0
                                        ? `Total requerido: ${cantidadTotal} pzs · Ya ordenado: ${yaOrdenado} pzs`
                                        : `Cantidad requerida en la requisición: ${cantidadTotal ?? requerido} pzs`
                                    }
                                  >
                                    <span style={{ color: "#ad6800", fontWeight: 600 }}>
                                      Requerido:
                                    </span>
                                    <span style={{ color: "#874d00", fontWeight: 800 }}>
                                      {requerido} pzs
                                    </span>
                                  </div>
                                )}
                              </td>
                              {proveedores.map((prov) => {
                                const celda = (ins.proveedores || []).find(
                                  (p) => p.proveedorId?.toString() === prov.proveedorId?.toString()
                                );
                                const esSeleccionado = seleccionadoProvId === prov.proveedorId?.toString();
                                const clickable = celda && !celda.error;
                                const esMejorPrecio =
                                  clickable &&
                                  typeof celda.precio === "number" &&
                                  mejorPrecio !== null &&
                                  celda.precio === mejorPrecio &&
                                  preciosValidos.length > 1;
                                const tieneVarias =
                                  celda?.tieneVariasRelaciones &&
                                  Array.isArray(celda.relaciones) &&
                                  celda.relaciones.length > 1;
                                const terminoSeleccionado = this.state.relacionesAsignadasScrap[ins.insumoId?.toString()];
                                return (
                                  <td
                                    key={prov.proveedorId}
                                    onClick={() =>
                                      !tieneVarias &&
                                      clickable &&
                                      this.seleccionarProveedorScrap(
                                        ins.insumoId,
                                        prov.proveedorId,
                                        celda?.terminoUsado,
                                        celda?.cantidadDisponible
                                      )
                                    }
                                    style={{
                                      cursor: !tieneVarias && clickable ? "pointer" : "default",
                                      background:
                                        esSeleccionado && !tieneVarias
                                          ? "#e6fffb"
                                          : esMejorPrecio && !tieneVarias
                                            ? "#f6ffed"
                                            : rowBg,
                                      border:
                                        esSeleccionado && !tieneVarias ? "2px solid #00BFD6" : undefined,
                                      borderBottom:
                                        esSeleccionado && !tieneVarias
                                          ? "2px solid #00BFD6"
                                          : "1px solid #f0f0f0",
                                      borderRight:
                                        esSeleccionado && !tieneVarias
                                          ? "2px solid #00BFD6"
                                          : "1px solid #e8e8e8",
                                      padding: tieneVarias ? 4 : 8,
                                      verticalAlign: "middle",
                                      transition: "background 0.15s",
                                    }}
                                  >
                                    {tieneVarias ? (
                                      <>
                                        {esMejorPrecio && (
                                          <div
                                            style={{
                                              fontSize: 9,
                                              color: "#52c41a",
                                              fontWeight: 600,
                                              marginBottom: 4,
                                              textTransform: "uppercase",
                                              letterSpacing: 0.5,
                                              textAlign: "center",
                                            }}
                                          >
                                            ★ Mejor precio
                                          </div>
                                        )}
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                          {celda.relaciones
                                            .filter((rel) => {
                                              if (!this.state.ocultarInsumosSinResultados) return true;
                                              return (
                                                rel &&
                                                !rel.error &&
                                                (typeof rel.precio === "number" ||
                                                  typeof rel.cantidadDisponible === "number" ||
                                                  rel.disponible === true)
                                              );
                                            })
                                            .map((rel) => {
                                            const subClickable = !rel.error;
                                            const subSeleccionada =
                                              esSeleccionado &&
                                              terminoSeleccionado &&
                                              rel.terminoUsado &&
                                              terminoSeleccionado.toString().trim().toLowerCase() ===
                                                rel.terminoUsado.toString().trim().toLowerCase();
                                            return (
                                              <div
                                                key={rel.terminoUsado}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (!subClickable) return;
                                                  this.seleccionarProveedorScrap(
                                                    ins.insumoId,
                                                    prov.proveedorId,
                                                    rel.terminoUsado,
                                                    rel.cantidadDisponible
                                                  );
                                                }}
                                                style={{
                                                  cursor: subClickable ? "pointer" : "default",
                                                  background: subSeleccionada ? "#e6fffb" : "#fff",
                                                  border: subSeleccionada
                                                    ? "2px solid #00BFD6"
                                                    : "1px solid #e8e8e8",
                                                  borderRadius: 6,
                                                  padding: "6px 8px",
                                                  textAlign: "center",
                                                  position: "relative",
                                                  boxShadow: subSeleccionada
                                                    ? "0 2px 6px rgba(0,191,214,0.35)"
                                                    : "none",
                                                  transition: "all 0.15s",
                                                }}
                                              >
                                                {subSeleccionada && (
                                                  <CheckCircleFilled
                                                    style={{
                                                      position: "absolute",
                                                      top: -6,
                                                      right: -6,
                                                      fontSize: 14,
                                                      color: "#00BFD6",
                                                      background: "#fff",
                                                      borderRadius: "50%",
                                                    }}
                                                  />
                                                )}
                                                <div
                                                  style={{
                                                    fontSize: 11,
                                                    color: subSeleccionada ? "#006d75" : "#595959",
                                                    fontWeight: 700,
                                                    marginBottom: 3,
                                                    letterSpacing: 0.3,
                                                  }}
                                                >
                                                  {rel.terminoUsado}
                                                </div>
                                                {this.renderCeldaScrap(rel, requerido)}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {celda?.terminoUsado && (
                                          <div
                                            style={{
                                              fontSize: 10,
                                              color: esSeleccionado ? "#006d75" : "#8c8c8c",
                                              fontWeight: 700,
                                              marginBottom: 2,
                                              letterSpacing: 0.3,
                                              textAlign: "center",
                                            }}
                                          >
                                            {celda.terminoUsado}
                                          </div>
                                        )}
                                        {this.renderCeldaScrap(celda, requerido)}
                                        {esMejorPrecio && (
                                          <div
                                            style={{
                                              fontSize: 9,
                                              color: "#52c41a",
                                              fontWeight: 600,
                                              marginTop: 2,
                                              textTransform: "uppercase",
                                              letterSpacing: 0.5,
                                            }}
                                          >
                                            ★ Mejor precio
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 12, fontSize: 11, color: "#8c8c8c" }}>
                    <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: "#52c41a", marginRight: 4, verticalAlign: "middle" }} /> Consulta exitosa</span>
                    <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: "#ff4d4f", marginRight: 4, verticalAlign: "middle" }} /> Error en la consulta</span>
                    <span style={{ color: "#52c41a", fontWeight: 600 }}>★ Mejor precio entre proveedores</span>
                  </div>
                </>
              );
            })()
          ) : null}
        </ModalItem>

        <ModalItem title="Confirmacion" visible={this.state.modalConfirmacion} onCancel={() => this.setState({ modalConfirmacion: false })}
          onOk={() => { this.setState({ modalConfirmacion: false }); if (this.state.tipo === 1) this.generarOrdenManual(this.state.valuesForm); else if (this.state.tipo === 2) this.generarOrdenInteligente(this.state.valuesForm); else if (this.state.tipo === 3) this.generarOrdenDefault(this.state.valuesForm); }}
          spinning={false} footer>
          <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
          <p style={{ textAlign: "center" }}>Se generaran {this.state.numOrdenesAGenerar} ordenes de compra</p>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    consultarProveedoresOnline: state.empresa.consultarProveedoresOnline,
  };
};

export default connect(mapStateToProps)(GenerarOrdenDeCompraConRequisicion);